/* eslint-disable quote-props, no-dupe-keys */
import Vue from 'vue'
import ElementLocale from 'element-ui/lib/locale'
import elementZhCN from 'element-ui/lib/locale/lang/zh-CN'
import elementEn from 'element-ui/lib/locale/lang/en'

const STORAGE_KEY = 'transport-ui-language'
const LANGUAGE_EVENT = 'transport-language-change'

const translations = {
  '全部待确认': 'All pending confirmations',
  '批量确认出账': 'Confirm selected bills',
  '已选订单': 'Selected orders',
  '待确认订单': 'Pending orders',
  '待扣押金合计': 'Total pending deposit charges',
  '来源账单': 'Source bill',
  '每次最多确认100条账单': 'Confirm up to 100 bills at a time.',
  '确认后统一出账；任一订单校验失败，本次所选订单均不扣款。': 'Confirm all selected bills together. If any order fails validation, none of the selected orders will be charged.',
  '批量确认出账完成，请核对最新记录': 'Bulk billing confirmation completed. Review the latest records.',
  '批量确认结果未完成，请刷新明细核对后重试': 'The bulk confirmation result is incomplete. Refresh the details and check before retrying.',

  '账单文件仍在导入，请等待导入完成后再确认出账': 'The billing file is still importing. Wait for the import to finish before confirming billing.',
  '押金金额或维护原因已变化，请刷新明细后重新确认': 'The deposit charge or explanation has changed. Refresh the details and review again.',
  '本次押金扣款金额已变化，请刷新明细后重新核对': 'The deposit charge has changed. Refresh the details and review it again.',
  '仅待确认的附加费账单可以确认出账，请刷新明细': 'Only pending extra-fee bills can be confirmed. Refresh the details.',
  '扣押金原因不能超过500个字符': 'The deposit charge explanation cannot exceed 500 characters.',
  '累计出账及待确认件数超过下单件数，请先核对待确认账单': 'Billed and pending pieces exceed the order quantity. Review the pending bills first.',
  '账单确认状态已变化，请刷新后重试': 'The billing confirmation status has changed. Refresh and try again.',

  '同名文件不能再次导入；不同名文件即使内容相同也按新账单累计，累计出账件数不能超过订单总件数。系统会逐行核对客户单号、主单号、件数和平台费用。每一次出账独立计算：客户端只显示本次件数对应的锁定售价；平台费用超过本次件数分摊成本的账单先进入待确认，管理员确认出账后（扣押金原因选填）才结算冻结费用、扣取押金及按目标值从余额补足；平台费用低于本次分摊成本的差额按“少补不退”记为本次强平，不能抵扣以后账单。件数为 0 时，整笔平台费用作为待确认的补充费用。导入完成后会逐行列出处理结果、具体原因和建议。确认导入？': 'A recorded filename cannot be imported again. Different filenames are treated as new billing occurrences; billed and pending pieces must not exceed the order quantity. Each bill is checked independently. Bills requiring an extra deposit charge await administrator confirmation before any charges are settled; the explanation is optional. Other bills settle automatically. Costs below the allocated cost follow the existing no-refund settlement rule and do not offset later bills. Zero-piece supplemental fees also require confirmation. Review all row results after import. Continue?',
  '待确认出账': 'Awaiting billing confirmation',
  '待确认押金': 'Deposit charge awaiting confirmation',
  '出账确认原因': 'Billing confirmation reason',
  '确认时间': 'Confirmed at',
  '确认出账': 'Confirm billing',
  '是否确定出账？': 'Confirm this bill and settle the charges?',
  '扣取押金金额': 'Deposit charge',
  '维护原因': 'Charge explanation',
  '确认扣款并出账': 'Confirm charges and billing',
  '请先维护扣押金原因，再确认出账': 'Enter the deposit charge explanation before confirming billing.',
  '请在导入明细确认出账，扣押金原因选填。确认前不会扣款。': 'Confirm billing in the import details; the deposit charge explanation is optional. No charges are settled before confirmation.',
  '已确认出账，费用已结算': 'Billing confirmed and charges settled.',
  '确认出账失败，请刷新明细后重试': 'Billing confirmation failed. Refresh the details and try again.',
  '完成': 'Done',
  '管理分组': 'Manage Groups',
  '先移出全部客户，再删除不再使用的分组。': 'Move all customers out before deleting a group you no longer need.',
  '系统默认，保留': 'System default · retained',
  '查看并移出客户': 'View and remove members',
  '删除分组': 'Delete Group',
  '默认分组不能删除': 'The default group cannot be deleted.',
  '请先移出分组内的全部客户，再删除分组': 'Remove all customers from the group before deleting it.',
  '确认删除此空分组？客户和推荐关系不会被删除。': 'Delete this empty group? Customers and referral relationships will be kept.',
  '分组已删除': 'Group deleted.',
  '分组删除失败，请重试': 'The group could not be deleted. Please try again.',
  '了解 LabelCheap': 'About LabelCheap',
  '分组用于客户分类和管理，支持单独或批量调整。': 'Organize customers into groups and update them individually or in bulk.',
  '分组调整不会修改客户的推荐关系。': 'Changing groups does not change referral relationships.',
  '按业务需要整理客户，查找和管理更方便。': 'Organize customers to make them easier to find and manage.',
  '分组名称': 'Group Name',
  '例如：重点客户、华东客户': 'e.g. Key Accounts, East Coast Customers',
  '最多60个字符，创建后即可将客户加入该分组。': 'Use up to 60 characters. You can assign customers after creating the group.',
  '为已选择的客户设置所属分组。': 'Choose a group for the selected customers.',
  '目标分组': 'Target Group',
  '请选择要加入的分组': 'Select a group to join',
  '位客户': 'customers',
  '仅调整客户所属分组，不修改推荐关系和返利归属。': 'Only group membership changes. Referral relationships and reward recipients stay the same.',
  '调整自动分组的最上级客户时，未手动分组的下级客户会一并归组。': 'Moving the top-level customer also moves automatically grouped descendants. Manual assignments are preserved.',
  '请先新增一个分组': 'Create a group first.',
  '移出后，所选客户将回到默认分组。确认移出？': 'Selected customers will return to the default group. Confirm removal?',

  '登录信息或菜单加载失败，请重新登录': 'Account details or menus could not be loaded. Please sign in again.',
  '页面加载失败，请刷新页面后重试': 'The page could not be loaded. Refresh the page and try again.',
  '登录失败，请稍后重试': 'Sign-in failed. Please try again later.',
  '客户分组': 'Customer Groups',
  '所有客户': 'All Customers',
  '默认分组': 'Default Group',
  '推广分组': 'Referral Group',
  '分组': 'Groups',
  '自动': 'Automatic',
  '手动': 'Manual',
  '新客户进入默认分组，推广上下级自动归组；手动调整优先保留。': 'New customers enter the default group. Referral chains are grouped automatically, while manual assignments take priority.',
  '刷新分组': 'Refresh Groups',
  '新增分组': 'Add Group',
  '已选择客户': 'Selected Customers',
  '加入分组': 'Add to Group',
  '移出分组': 'Remove from Group',
  '分组不改变推荐关系，返利仍只计算直属一层。': 'Groups do not change referral relationships. Rewards remain limited to direct referrals.',
  '请输入分组名称': 'Enter a group name',
  '创建分组': 'Create Group',
  '请选择分组': 'Select a group',
  '手动分组会保留；移动最上级推荐人时，其自动归组的下级会跟随。': 'Manual assignments are preserved. Moving the top-level referrer also moves their automatically grouped descendants.',
  '确认加入': 'Confirm Assignment',
  '客户分组读取失败，请重试': 'Customer groups could not be loaded. Please try again.',
  '分组名称须为1至60个字符': 'Group names must contain 1 to 60 characters.',
  '客户分组已创建': 'The customer group has been created.',
  '客户分组创建失败': 'The customer group could not be created.',
  '请先新增分组，或等待推广关系自动生成分组': 'Create a group first, or use a group created automatically by a referral relationship.',
  '客户已加入分组': 'Customers have been added to the group.',
  '客户分组保存失败': 'The customer group assignment could not be saved.',
  '移出后回到默认分组，不会解除推荐关系或改变返利。确认移出？': 'Removed customers return to the default group. Referral relationships and rewards are unchanged. Confirm removal?',
  '确认移出': 'Confirm Removal',
  '客户已移回默认分组': 'Customers have been returned to the default group.',
  '分组名称已存在': 'The group name already exists.',
  '请选择1至500个客户及有效分组': 'Select 1 to 500 customers and a valid group.',
  '客户分组不存在，请刷新后重试': 'The customer group does not exist. Refresh and try again.',
  '只能调整普通客户的分组，请刷新后重试': 'Only customer accounts can be assigned to groups. Refresh and try again.',
  '推广关系存在循环，分组操作已回滚': 'A referral cycle was detected. The group operation was rolled back.',
  '客户分组保存失败，操作已回滚': 'The customer group could not be saved. The operation was rolled back.',
  '是否住宅': 'Residential',
  '住宅附加费': 'Residential Surcharge',
  '客户资金流水': 'Customer Transactions',
  '余额提示': 'Balance Reminder',
  '可预报余额': 'Available Shipping Balance',
  '余额不足': 'Insufficient Balance',
  '余额偏低': 'Low Balance',
  '查看账户': 'View Account',
  '您的可预报余额已低于 50.00 USD，请及时安排充值，避免影响订单预报和货物正常流转，谢谢。': 'Your available shipping balance is below USD 50.00. Please arrange a top-up promptly to avoid disruption to order submission and shipment processing. Thank you.',
  '可用余额不足以支付本次运费时，将无法提交预报。': 'You will not be able to submit an order if the available balance cannot cover its shipping cost.',
  '充值、撤销及退款记录': 'Recharges, Reversals and Refunds',
  '仅展示充值、充值撤销及退款记录，含押金充值和退还；金额按各记录所属账户展示。': 'Only recharges, recharge reversals and refunds are shown, including deposit top-ups and returns. Amounts reflect the account shown on each transaction.',
  '包含充值、撤销、退款、扣费及押金变动；金额按各记录所属账户展示。': 'Includes recharges, reversals, refunds, charges and deposit changes. Amounts reflect the account shown on each transaction.',
  '住宅附加费筛选': 'Residential surcharge filter',
  '有住宅附加费': 'With residential surcharge',
  '无住宅附加费': 'Without residential surcharge',
  '此渠道会额外收取住宅附加费': 'An additional residential surcharge applies to this service',
  '开启后，该渠道的试算产品名称旁将显示住宅附加费提示。': 'When enabled, a residential surcharge notice appears beside this service in the quote results.',
  '设为住宅后，试算显示住宅地址；关闭后仍按接口判断。': 'When enabled, quotes show Residential Address. When disabled, the carrier response still determines the address type.',
  '产品住宅设置已保存': 'The product residential setting has been saved.',
  '产品住宅设置保存失败': 'The product residential setting could not be saved.',
  '产品住宅设置保存失败，请刷新后重试': 'The product residential setting could not be saved. Refresh and try again.',
  '是否住宅必须选择是或否': 'Select Yes or No for the residential setting.',
  '可用余额 = 当前余额 - 冻结金额。订单创建后冻结费用，生成账单时正式扣除；预报明确失败时立即释放，成功订单删除后次日释放。充值会先补足押金缺口，剩余金额进入余额。': 'Available balance = current balance - frozen amount. Order fees are frozen at creation and deducted when billed. Confirmed submission failures release funds immediately; successful orders deleted later release funds the next day. Top-ups first cover the deposit shortfall, with the remainder credited to the balance.',
  '预报失败，冻结金额已立即释放': 'Submission failed. The frozen amount has been released immediately.',
  '预报失败的订单将移入回收站，冻结金额立即释放，已释放的不会重复退还。确认删除？': 'The failed order will be moved to the recycle bin. Frozen funds are released immediately and will not be returned twice. Confirm deletion?',
  '订单已移入回收站，冻结款已释放，不会重复退还': 'Order moved to the recycle bin. Frozen funds have been released and will not be returned twice.',

  '推广返利': 'Referral Rewards',
  '该客户已有推广关系，请停用账号，不能删除': 'This customer has referral relationships. Disable the account instead of deleting it.',
  '推广管理': 'Referral Management',
  '我的推广': 'My Referrals',
  '仅直属推荐享有返利，订单全部出账并正式扣款完成后才计入收益。': 'Only direct referrals earn rewards, after the entire order has been billed and actually charged.',
  '返利比例设置': 'Reward Rate',
  '新比例仅用于后续新订单，已有订单保留原比例。': 'New rates apply only to future orders. Existing orders retain their original rates.',
  '返利比例（%）': 'Reward Rate (%)',
  '保存比例': 'Save Rate',
  '全部客户推荐关系': 'All Customer Referral Relationships',
  '搜索客户账号或姓名': 'Search customer account or name',
  '客户账号': 'Customer Account',
  '客户姓名': 'Customer Name',
  '直接推荐人': 'Direct Referrer',
  '直属推荐人数': 'Direct Referrals',
  '有效完成订单': 'Eligible Completed Orders',
  '累计净返利（USD）': 'Net Rewards (USD)',
  '推广待抵扣（USD）': 'Reward Recovery Due (USD)',
  '查看推广详情': 'View Referral Details',
  '返回推广总览': 'Back to Overview',
  '专属邀请码': 'Your Invitation Code',
  '新用户开户后，在首次下单前绑定您的邀请码。': 'New customers can bind your invitation code after account creation, before placing their first order.',
  '复制邀请码': 'Copy Code',
  '未绑定': 'Not Linked',
  '绑定推荐人': 'Link a Referrer',
  '绑定后不可更改，首次下单后不能再绑定；不允许自己推荐自己或循环推荐。': 'This link is permanent and must be made before the first order. Self-referrals and referral cycles are prohibited.',
  '输入推荐人的邀请码': 'Enter your referrer’s invitation code',
  '确认绑定': 'Confirm Link',
  '直属客户': 'Direct Customers',
  '绑定时间': 'Linked At',
  '带来的净返利（USD）': 'Net Rewards Generated (USD)',
  '返利订单': 'Referral Orders',
  '返利基数（USD）': 'Reward Base (USD)',
  '订单返利比例': 'Order Reward Rate',
  '当前返利（USD）': 'Current Reward (USD)',
  '已完成结算': 'Settlement Completed',
  '未满足返利条件': 'Not Yet Eligible',
  '收益流水': 'Reward Transactions',
  '收益变动（USD）': 'Reward Change (USD)',
  '余额变动（USD）': 'Wallet Change (USD)',
  '待抵扣变动（USD）': 'Recovery Due Change (USD)',
  '剩余待抵扣（USD）': 'Remaining Recovery Due (USD)',
  '返利按订单原始客户金额计算，不含充值、押金补缴和附加费；只返给直接推荐人。': 'Rewards use the original customer order amount, excluding top-ups, deposit funding, and extra fees. Only the direct referrer earns a reward.',
  '账单撤销会冲回返利；可用余额不足的部分记为推广待抵扣，由后续返利优先抵扣，不占用押金或冻结资金。': 'Revoked bills reverse rewards. Any amount not recoverable from available funds is offset against future rewards, without using deposits or frozen funds.',
  '推广数据读取失败，请重试': 'Referral data could not be loaded. Please try again.',
  '返利比例已保存': 'The reward rate has been saved.',
  '请输入有效的邀请码': 'Enter a valid invitation code.',
  '推荐关系绑定后不可更改，确认绑定此邀请码？': 'This referral link cannot be changed. Link this invitation code?',
  '推荐人已绑定': 'The referrer has been linked.',
  '绑定失败': 'The referral link could not be saved.',
  '邀请码已复制': 'Invitation code copied.',
  '复制失败，请手动复制邀请码': 'Copy failed. Please copy the invitation code manually.',
  '推广功能仅适用于客户账户': 'Referrals are available only for customer accounts.',
  '返利比例应在0至100之间，最多两位小数': 'The reward rate must be between 0 and 100, with up to two decimal places.',
  '邀请码无效': 'Invalid invitation code.',
  '推荐关系已绑定，不能更改': 'The referral link already exists and cannot be changed.',
  '仅首次下单前可以绑定推荐人': 'A referrer can be linked only before the first order.',
  '不能绑定自己或形成循环推荐': 'Self-referrals and referral cycles are not allowed.',
  '推广记录写入失败，操作已回滚': 'The referral record could not be saved. The operation was rolled back.',
  '推广资金更新失败': 'The referral wallet update failed.',
  '推广流水写入失败': 'The referral transaction could not be recorded.',
  '推荐返利': 'Referral Reward',
  '返利冲回': 'Reward Reversal',
  '推荐返利净额': 'Net Referral Rewards',
  '直属推荐订单完成返利': 'Reward for a completed direct-referral order',
  '直属推荐订单返利冲回': 'Reward reversal for a direct-referral order',
  '中文版': 'Chinese',
  '使用说明': 'User Guide',
  '使用说明管理': 'User Guide Management',
  '使用说明目录': 'User Guide Contents',
  '目录': 'Contents',
  '选择目录查看内容': 'Select a topic to read',
  '未命名目录': 'Untitled Topic',
  '目录操作': 'Topic Actions',
  '在上方添加目录': 'Insert Topic Before',
  '在下方添加目录': 'Insert Topic After',
  '添加子目录': 'Add Subtopic',
  '删除目录': 'Delete Topic',
  '添加一级目录': 'Add Top-Level Topic',
  '可拖动目录调整顺序或层级，最多支持6级。': 'Drag topics to change their order or hierarchy, up to 6 levels.',
  '当前位置': 'Current Location',
  '编辑当前目录': 'Edit Current Topic',
  '目录名称': 'Topic Name',
  '在此插入段落': 'Insert Paragraph Here',
  '可在这里添加内容，也可以继续添加子目录。': 'Add content here or create subtopics.',
  '本目录暂无内容': 'This topic has no content yet.',
  '目录数量或层级已达上限': 'The topic count or nesting limit has been reached.',
  '删除该目录及全部子目录和内容？': 'Delete this topic, all its subtopics, and their content?',
  '请至少保留一个一级目录': 'Keep at least one top-level topic.',
  '使用说明读取失败，请重试': 'The user guide could not be loaded. Please try again.',
  '重新加载': 'Reload',
  '保存发布后，用户端重新打开页面即可查看最新内容。': 'After publishing, customers can reopen this page to view the latest content.',
  '编辑内容': 'Edit Content',
  '保存发布': 'Save and Publish',
  '继续编辑': 'Continue Editing',
  '预览效果': 'Preview',
  '页面内容': 'Page Content',
  '说明标题': 'Guide Title',
  '开场说明': 'Introduction',
  '操作步骤': 'Workflow Steps',
  '添加步骤': 'Add Step',
  '章节': 'Section',
  '上移': 'Move Up',
  '下移': 'Move Down',
  '删除章节': 'Remove Section',
  '章节标题': 'Section Title',
  '段落': 'Paragraph',
  '删除段落': 'Remove Paragraph',
  '段落标题': 'Paragraph Title',
  '段落正文': 'Paragraph Text',
  '补充列表（可选，每行一项）': 'Additional List (optional, one item per line)',
  '突出显示为重要提醒': 'Highlight as an important reminder',
  '添加段落': 'Add Paragraph',
  '添加章节': 'Add Section',
  '页尾提醒': 'Closing Reminder',
  '提醒标题': 'Reminder Title',
  '提醒正文': 'Reminder Text',
  '页脚文字': 'Footer Text',
  '尚有未发布的修改，确定放弃吗？': 'You have unpublished changes. Discard them?',
  '放弃修改': 'Discard Changes',
  '使用说明已发布': 'The user guide has been published.',
  '使用说明保存失败，请重试': 'The user guide could not be saved. Please try again.',
  '使用说明版本无效，请刷新后重试': 'The guide version is invalid. Reload the page and try again.',
  '使用说明语言无效，请选择中文版或英文版': 'Select the Chinese or English version of the user guide.',
  '使用说明已被其他管理员更新，请重新加载后再编辑': 'Another administrator has updated this guide. Reload it before editing again.',
  '请完整填写使用说明，并检查章节、段落及文字长度': 'Complete the guide and check its sections, paragraphs, and text lengths.',
  '此邮编暂无上游城市记录，请核对邮编或联系客服': 'No shipping provider cities are recorded for this ZIP. Check the ZIP or contact support.',
  '邮编城市读取失败，请重试或联系客服': 'The ZIP city lookup failed. Try again or contact support.',
  '请等待邮编城市读取完成': 'Please wait for the ZIP city lookup to finish.',
  '请选择上游邮编对应的城市': 'Select a city returned by the shipping provider for this ZIP.',
  // Deposit list and threshold transfers
  '押金列表': 'Deposit List',
  '充值总额按入余额和入押金分别列出；阈值调整和账户内部划转请在资金流水查看。': 'Each recharge shows its wallet and deposit portions. See Transaction Details for threshold changes and internal transfers.',
  '入余额 (USD)': 'To Wallet (USD)',
  '入押金 (USD)': 'To Deposit (USD)',
  '余额充值入账净额': 'Net Wallet Recharge Credits',
  '补足押金净额': 'Net Deposit Replenishment',
  '撤回': 'Reverse',
  '已撤回': 'Reversed',
  '押金充值撤回': 'Deposit Credit Reversal',
  '押金充值撤回通知': 'Deposit Credit Reversal Notice',
  '撤回押金充值': 'Reverse Deposit Credit',
  '确认撤回': 'Confirm Reversal',
  '押金充值已撤回，原记录已保留': 'The deposit credit has been reversed. The original record is retained.',
  '当前押金不足，无法撤回这条押金充值；请先核对后续押金流水': 'The current deposit is insufficient to reverse this credit. Review subsequent deposit transactions first.',
  '押金列表读取失败，请点击刷新重试': 'The deposit list could not be loaded. Click Refresh to try again.',
  '押金列表数据格式异常，请刷新重试': 'The deposit list response is invalid. Refresh to try again.',
  '当前阈值': 'Current Threshold',
  '设置客户应维持的押金金额': 'Set the security deposit amount this customer should maintain',
  '新的押金阈值': 'New Deposit Threshold',
  '调整预览': 'Adjustment Preview',
  '无需补足': 'No Shortfall',
  '上调阈值：余额足够时补足差额，余额不足时显示待补押金。': 'Increase: the balance covers the full gap when sufficient; otherwise, the deposit gap remains outstanding.',
  '下调阈值：超出新阈值的押金退回余额。': 'Decrease: any deposit above the new threshold returns to the balance.',
  '实际金额以保存时账户状态为准。': 'Final amounts depend on the account state when you save.',
  '所有调整均保留流水记录': 'All adjustments are recorded',
  '预计从余额补入押金': 'Estimated Transfer to Deposit',
  '预计退回余额': 'Estimated Return to Balance',
  '调整后待补押金': 'Outstanding Deposit After Adjustment',
  '确认调整': 'Confirm Adjustment',
  '上调时，可用余额足够则一次补足差额；不足时不扣余额，差额显示为待补押金。下调时，当前押金超过新阈值的部分退回余额。所有调整保留流水，实际结果以保存时账户状态为准。': 'When increasing the threshold, the full gap is transferred if available funds cover it; otherwise the balance is unchanged and the gap remains outstanding. When lowering it, any deposit above the new threshold returns to the balance. All adjustments are recorded. Final amounts depend on the account at the time of saving.',
  '查看所有客户的押金标准与待补情况，待补客户优先展示。': 'Review deposit thresholds and outstanding amounts for all customers. Customers with outstanding deposits appear first.',
  '客户总数': 'Total Customers',
  '待补客户': 'Customers with Outstanding Deposits',
  '待补押金合计': 'Total Outstanding Deposit',
  '搜索客户账号或名称': 'Search customer account or name',
  '仅看待补': 'Outstanding Only',
  '修改押金阈值': 'Edit Deposit Threshold',
  '押金阈值调整': 'Deposit Threshold Adjustment',
  '阈值下调退押金': 'Deposit Released by Threshold Reduction',
  '余额转入押金': 'Balance Transferred to Deposit',
  '押金退回余额': 'Deposit Returned to Balance',
  // Customer usage guide
  '使用指南': 'User Guide',
  '注意事项': 'Important Information',
  '从准备资料到下载面单，按以下步骤完成下单。使用中遇到问题，请及时联系我们反馈。': 'Follow these steps from preparing shipment details to downloading labels. If you encounter a problem, please contact us.',
  '准备资料': 'Prepare Details',
  '创建订单': 'Create Order',
  '核对并提交': 'Review and Submit',
  '下载面单': 'Download Label',
  '提交前，多核对一次': 'Check once more before submitting',
  '地址、邮编、重量、尺寸和产品选择会影响下单结果与费用。请以实际包裹信息填写，并保留订单号和面单，方便后续查询与反馈。': 'Addresses, postal codes, weight, dimensions and product selection affect orders and charges. Enter actual parcel details and keep your order number and label for future enquiries.',
  '开始使用前': 'Before You Start',
  '准备寄件资料': 'Prepare shipment details',
  '提前准备寄件人和收件人的姓名、电话、完整地址、国家及邮编。请确认信息真实准确，避免地址错误导致下单失败或派送异常。': 'Prepare sender and recipient names, phone numbers, full addresses, countries and postal codes. Check all details to avoid order failures or delivery problems.',
  '测量包裹并查看账户': 'Measure parcels and check your account',
  '按页面标注的单位填写每个包裹的实际重量和长、宽、高，不要估填或混用单位。下单前可在“资金账户”查看可用余额，余额不足时请联系工作人员处理。': 'Enter the actual weight, length, width and height of each parcel using the units shown. Do not estimate or mix units. Check your available balance in Funds Account before ordering; contact our team if funds are insufficient.',
  '如何下单与打印面单': 'How to Order and Print Labels',
  '第一步：进入创建订单': 'Step 1: Create an order',
  '在“末端打单”中进入“创建订单”，填写寄件地址、收件地址以及包裹信息；使用已保存资料时，也请再次核对是否适用于本次寄件。': 'Open Create Order under Last-mile Shipping. Enter sender, recipient and parcel details. When using saved details, check that they apply to this shipment.',
  '第二步：选择产品并核对费用': 'Step 2: Choose a product and review charges',
  '根据目的地和包裹情况选择产品，按页面提示进行运费试算。确认产品、服务和费用信息后再提交；试算金额供下单参考，最终费用请查看后续账务记录。': 'Choose a product suitable for the destination and parcel, then request a shipping quote as prompted. Review the product, services and charges before submitting. Quotes are estimates; consult subsequent billing records for final charges.',
  '第三步：提交并查看结果': 'Step 3: Submit and check the result',
  '提交后请等待系统返回结果，并在“订单管理”查看订单状态。如遇超时、报错或结果不明确，请先查询是否已生成订单，再决定是否重试，避免重复下单。': 'Wait for the result after submitting and check the status in Order Management. If a request times out, fails or returns an unclear result, check whether an order was created before retrying to avoid duplicates.',
  '第四步：下载并打印面单': 'Step 4: Download and print the label',
  '订单成功且面单生成后，在订单中下载并打印面单。交寄前核对面单与包裹是否对应，确保条码清晰、完整，避免遮挡或折叠。': 'Once the order succeeds and a label is available, download and print it from the order. Match each label to its parcel before dispatch and keep the barcode clear, complete and free from folds or obstruction.',
  '订单跟进与问题反馈': 'Order Follow-up and Support',
  '及时查看订单与账务': 'Check orders and account activity',
  '下单后可在“订单管理”跟进订单，在资金相关页面核对余额与费用明细，同时留意首页的系统公告和消息通知。': 'Track orders in Order Management and check balances and charge details in the finance pages. Also review announcements and messages on the home page.',
  '遇到问题，联系我们': 'Contact us when you need help',
  '如遇登录异常、下单失败、面单无法下载或费用疑问，请通过平时与我们联系的客服或业务人员反馈。请提供订单号（如有）、操作时间、操作步骤及报错截图，方便我们尽快核查。': 'For login issues, failed orders, label download problems or charge enquiries, contact your usual customer service or account representative. Include the order number if available, operation time, steps taken and a screenshot of the error.',
  '反馈时保护账号信息': 'Protect your account information',
  '请勿提供登录密码或验证码。截图中如包含收件人电话、详细地址等个人信息，请按核查需要遮挡无关内容。涉及索赔或争议时，可在对应菜单提交资料并关注处理进度。': 'Never share passwords or verification codes. Hide personal details such as recipient phone numbers and addresses in screenshots when they are not needed for investigation. For claims or disputes, submit documents through the corresponding menu and follow the progress.',
  // Layout and navigation
  '工作台': 'Dashboard',
  '系统通知': 'System Notices',
  '系统公告': 'System Announcements',
  '消息通知': 'Messages',
  '消息中心': 'Message Center',
  '用户管理': 'User Management',
  '角色管理': 'Role Management',
  '菜单管理': 'Menu Management',
  '通知公告': 'Announcements',
  '文件管理': 'File Management',
  '头像文件': 'Avatar Files',
  '其他文件': 'Other Files',
  '操作日志': 'Operation Logs',
  '登录日志': 'Login Logs',
  '系统配置': 'System Settings',
  '系统设置': 'System Settings',
  '字典管理': 'Dictionary Management',
  '监控管理': 'Monitoring',
  '在线用户': 'Online Users',
  '服务监控': 'Service Monitor',
  '缓存监控': 'Cache Monitor',
  '缓存管理': 'Cache Management',
  '定时任务': 'Scheduled Jobs',
  '末端打单': 'Shipping Operations',
  '财务中心': 'Finance Center',
  '账户总览': 'Account Overview',
  '充值管理': 'Recharge Management',
  '资金流水': 'Transactions',
  '利润报表': 'Profit Report',
  '快速查单': 'Quick Quote',
  '创建订单': 'Create Order',
  '产品列表': 'Products',
  '订单管理': 'Order Management',
  '索赔管理': 'Claims',
  '财务结算': 'Finance',
  '资金账号': 'Accounts',
  '费用明细': 'Transaction Details',
  '账单管理': 'Statements',
  '利润统计': 'Profit Statistics',
  '押金管理': 'Deposit Management',
  '产品运费加价配置': 'Product Markup',
  '利润管理': 'Profit Management',
  '客户产品利润配置': 'Customer Product Markup',
  '客户专属': 'Customer rate',
  '通用': 'Default rate',
  '请选择客户': 'Select a customer',
  '暂无产品': 'No products',
  '只对当前选择的客户生效；历史订单使用下单时保存的比例。': 'Applies only to the selected customer. Existing orders retain their saved markup.',
  '常用联系人': 'Contacts',
  '总余额': 'Total Balance',
  '余额关系': 'Balance Formula',
  '待补押金说明': 'Deposit Shortfall',
  '目标押金减去当前押金，就是还需要补交的金额；如果当前押金已达标，待补押金显示 0。': 'The target deposit minus the current deposit is the amount still due. If the target has already been reached, the amount due is 0.',
  '冻结金额释放或正式扣除后，可用余额会同步变化。': 'Available balance updates when frozen funds are released or charged.',
  '订单费用冻结': 'Order Hold',
  '订单冻结释放': 'Order Hold Released',
  '充值时会优先补足待补押金，剩余金额进入总余额。': 'A recharge first covers the deposit shortfall; the remainder is added to total balance.',
  '常用包裹': 'Saved Packages',
  '选择常用包裹': 'Select a saved package',
  '刷新常用包裹': 'Refresh saved packages',
  '新增常用包裹': 'Add Saved Package',
  '包裹名称': 'Package Name',
  '重量单位': 'Weight Unit',
  '尺寸单位': 'Dimension Unit',
  '保险币种': 'Insurance Currency',
  '设为默认': 'Set as Default',
  '暂无常用包裹': 'No saved packages',
  '回收站': 'Recycle Bin',
  '个人中心': 'Profile',
  '退出登录': 'Sign out',
  '全屏显示': 'Full screen',
  '全屏展示': 'Full screen',
  '语言': 'Language',
  '中文': '中文',
  '英文': 'English',
  '公告管理': 'Announcement Management',
  '网站配置': 'Website Settings',
  '代码生成': 'Code Generation',
  '代码生成日志': 'Code Generation History',

  // Authentication and common actions
  '客户门户登录': 'Customer portal login',
  '管理员后台登录': 'Administrator login',
  'LabelCheap': 'LabelCheap',
  '欢迎使用 LabelCheap': 'Welcome to LabelCheap',
  '欢迎回来': 'Welcome back',
  '管理员后台 · 请输入账号继续': 'Administrator portal · Sign in to continue',
  '客户门户 · 请输入账号继续': 'Customer portal · Sign in to continue',
  '请输入用户名': 'Enter username',
  '请输入密码': 'Enter password',
  '密码': 'Password',
  '验证码': 'Captcha',
  '忘记密码？': 'Forgot your password?',
  '请联系系统管理员重置密码': 'Please contact the system administrator to reset your password',
  '点击刷新验证码': 'Click to refresh captcha',
  '正在登录...': 'Signing in...',
  '登录': 'Sign in',
  '登录成功': 'Signed in successfully',
  '用户名不能为空': 'Username is required',
  '密码不能为空': 'Password is required',
  '验证码不能为空': 'Captcha is required',
  '安全验证': 'Security verification',
  '刷新验证': 'Refresh verification',
  '拖动滑块，将拼图移至缺口': 'Drag the slider to fit the piece into the gap',
  '向右拖动滑块': 'Drag the slider to the right',
  '验证通过': 'Verified',
  '正在加载验证...': 'Loading verification...',
  '正在验证...': 'Verifying...',
  '请刷新后重试': 'Refresh to try again',
  '验证加载失败，点击刷新重试': 'Unable to load verification. Refresh to retry.',
  '验证已过期，请刷新重试': 'Verification expired. Refresh to retry.',
  '验证未通过，请重试': 'Verification failed. Please try again.',
  '请先完成拖动验证': 'Please complete the slider verification first',
  '不再显示': "Don't show again",
  '总押金': 'Total Deposit',
  '客户分组读取失败': 'Unable to load customer groups',
  '未命名分组': 'Unnamed Group',
  '住宅地址筛选': 'Residential address filter',
  '仅住宅地址': 'Residential addresses only',
  '仅非住宅地址': 'Non-residential addresses only',
  '全部分组': 'All Groups',
  '验证码加载失败，请点击图片重试': 'The captcha could not be loaded. Click the image to try again.',
  '请输入所有内容': 'Please complete all required fields',
  '你好': 'Hello',
  '确定注销并退出系统吗？': 'Sign out of the system?',
  '提示': 'Notice',
  '确定': 'Confirm',
  '取消': 'Cancel',
  '关闭': 'Close',
  '保存': 'Save',
  '编辑': 'Edit',
  '删除': 'Delete',
  '新增': 'Add',
  '查询': 'Search',
  '重置': 'Reset',
  '刷新': 'Refresh',
  '返回': 'Back',
  '查看': 'View',
  '处理': 'Process',
  '确认提交': 'Confirm submission',
  '导出': 'Export',
  '查看全部': 'View All',
  '更多': 'More',
  '最近': 'Recent',
  '刷新数据': 'Refresh Data',

  // Shipping and order entry
  '产品信息': 'Product Information',
  '仅查询价格': 'Price lookup only',
  '包裹与目的地': 'Package and Destination',
  '输入美国收件邮编和单件包裹数据，查看各产品预估运费。': 'Enter a US destination ZIP code and single-package measurements to compare estimated shipping prices.',
  '美国 5 位邮编': '5-digit US ZIP code',
  '正在识别邮编': 'Looking up ZIP code',
  '暂时无法识别此邮编，请稍后重试': 'This ZIP code could not be found. Please try again later.',
  '单件重量': 'Weight per package',
  '长度': 'Length',
  '宽度': 'Width',
  '高度': 'Height',
  '查询预估价格': 'Get Estimated Prices',
  '按单件、1 件试算；结果包括当前产品加价。': 'Estimated for one package; prices include the current product markup.',
  '产品报价': 'Product Quotes',
  '正在向平台试算': 'Requesting provider quotes',
  '已返回': 'Received',
  '个产品': 'products',
  '查询后显示美东、美中、美西产品的预估价格': 'Estimated prices for US East, Central, and West products will appear here.',
  '预估价仅供参考：上游接口要求完整收件信息，本查询使用邮编对应的州/城市和估价占位地址。住宅、偏远及其他附加费可能因实际地址改变；最终金额以创建订单时的完整试算为准。': 'Estimates are for reference only. The provider requires a full address, so this lookup uses the ZIP code location and an estimate-only placeholder address. Residential, remote-area, and other surcharges may change with the actual address. The full quote on Create Order determines the final price.',
  '预估价格': 'Estimated Price',
  '输入包裹信息后查询价格': 'Enter package details to get prices',
  '不会创建订单，也不会扣除账户余额。': 'This does not create an order or charge your account.',
  '产品读取失败，请刷新页面重试': 'Unable to load products. Refresh the page and try again.',
  '请输入有效的美国 5 位邮编': 'Enter a valid 5-digit US ZIP code.',
  '请等待邮编识别完成后再查询': 'Wait for the ZIP code lookup to finish.',
  '正在加载产品，请稍后重试': 'Products are loading. Please try again shortly.',
  '请先输入有效的美国邮编并等待州省、城市解析完成': 'Enter a valid US ZIP code and wait for the city and state lookup to finish.',
  '重量和长宽高必须填写有效数字': 'Enter valid numbers for weight and dimensions.',
  '重量和长宽高须大于0且不超过999；重量最多三位小数，尺寸最多一位小数': 'Weight and dimensions must be greater than 0 and no more than 999. Use up to three decimals for weight and one for dimensions.',
  '每次请选择1至8个产品试算': 'Select 1 to 8 products per quote request.',
  '当前没有可试算的产品，请联系管理员': 'No products are available for quoting. Contact an administrator.',
  '该产品未返回试算结果': 'The provider did not return a quote for this product.',
  '试算失败，请重试': 'Quote failed. Please retry.',
  '未收到试算结果': 'No quote result was received.',
  '产品': 'Product',
  '产品编码': 'Product Code',
  '产品名称': 'Product Name',
  '产品分类': 'Product Category',
  '产品特性': 'Product Features',
  '产品状态': 'Product Status',
  '全部产品': 'All Products',
  '请选择产品': 'Select a product',
  '请选择发货区域': 'Select a shipping region',
  '发货区域': 'Shipping Region',
  '收件信息': 'Recipient Information',
  '寄件信息': 'Sender Information',
  '收件人': 'Recipient',
  '收件公司': 'Recipient Company',
  '收件电话': 'Recipient Phone',
  '收件邮箱': 'Recipient Email',
  '收件国家': 'Recipient Country',
  '收件州省': 'Recipient State',
  '收件城市': 'Recipient City',
  '收件邮编': 'Recipient ZIP Code',
  '收件地址': 'Recipient Address',
  '寄件人': 'Sender',
  '寄件公司': 'Sender Company',
  '寄件电话': 'Sender Phone',
  '寄件邮箱': 'Sender Email',
  '寄件国家': 'Sender Country',
  '寄件州省': 'Sender State',
  '寄件城市': 'Sender City',
  '寄件邮编': 'Sender ZIP Code',
  '寄件地址': 'Sender Address',
  '包裹信息': 'Package Information',
  '增加包裹': 'Add Package',
  '件数': 'Pieces',
  '重量': 'Weight',
  '长': 'Length',
  '宽': 'Width',
  '高': 'Height',
  '尺寸': 'Dimensions',
  '实重': 'Actual Weight',
  '计费重': 'Chargeable Weight',
  '参考编号': 'Reference No.',
  '参考编号1': 'Reference No. 1',
  '参考编号2': 'Reference No. 2',
  '保险价值': 'Insured Value',
  '币别': 'Currency',
  '发货': 'Ship',
  '取件': 'Pickup',
  '派件': 'Delivery',
  '仓库编码': 'Warehouse Code',
  '签名服务': 'Signature Service',
  '普通签名': 'Standard Signature',
  '成人签名': 'Adult Signature',
  '货物类型': 'Goods Type',
  '申报币种': 'Declared Currency',
  '密度': 'Density',
  '示例': 'Example',
  '必填': 'Required',
  '自动识别': 'Auto-detect',
  '识别并填入': 'Detect and fill',
  '试算结果': 'Rate Quote',
  '运费试算': 'Rate Quote',
  '试算': 'Calculate',
  '提交预报': 'Submit Shipment',
  '正在等待平台返回结果，请稍后': 'Waiting for a response from the provider. Please wait.',
  '订单正在提交，请勿重复操作或关闭页面。': 'Your shipment is being submitted. Please do not submit again or close this page.',
  '正在导入平台账单，请稍后': 'Importing the provider statement. Please wait.',
  '正在读取并核对 Excel 账单，请勿重复导入或关闭页面。': 'Reading and matching the Excel statement. Do not import it again or close this page.',
  '确认预报': 'Confirm Shipment',
  '清空选择': 'Clear Selection',
  '全选': 'Select All',
  '复制此包裹': 'Duplicate Package',
  '删除此包裹': 'Delete Package',
  '接口提交': 'API submission',
  '换算': 'Converted',
  '当前显示': 'Currently Showing',

  // Orders and tracking
  '订单': 'Order',
  '订单号码': 'Order No.',
  '订单号': 'Order No.',
  '运单号码': 'Waybill No.',
  '订单日期': 'Order Date',
  '订单状态': 'Order Status',
  '订单列表': 'Order List',
  '订单详情': 'Order Details',
  '订单管理': 'Order Management',
  '客户订单': 'Customer Orders',
  '客户': 'Customer',
  '客户名称': 'Customer Name',
  '客户账号': 'Customer Account',
  '订单数': 'Order Count',
  '订单单位': 'Order Units',
  '预报重量': 'Forecast Weight',
  '预扣费金额': 'Pre-deduction',
  '已出账金额': 'Billed Amount',
  '平台出账金额': 'Provider Billed Amount',
  '客户展示平台出账金额': 'Customer Billed Amount',
  '导入账单': 'Import Statement',
  '导入平台账单': 'Import Provider Statement',
  '账单导入完成': 'Statement Import Complete',
  '账单导入失败': 'Statement Import Failed',
  '仅支持 .xlsx 格式的账单文件': 'Only .xlsx statement files are supported',
  '押金扣款': 'Deposit Deduction',
  '扣款笔数': 'Deduction Count',
  '订单状态查询': 'Order Status',
  '订单轨迹': 'Shipment Tracking',
  '轨迹': 'Tracking',
  '刷新订单': 'Refresh Orders',
  '刷新轨迹': 'Refresh Tracking',
  '查看面单': 'View Label',
  '下载面单': 'Download Label',
  '快递面单': 'Shipping Label',
  '回收站': 'Recycle Bin',
  '恢复订单': 'Restore Order',
  '删除订单': 'Delete Order',
  '成功订单押金管理': 'Successful Order Deposits',

  // Finance
  '余额': 'Balance',
  '当前余额': 'Current Balance',
  '可用余额': 'Available Balance',
  '押金': 'Deposit',
  '充值': 'Recharge',
  '充值记录': 'Recharge Records',
  '充值金额': 'Recharge Amount',
  '充值时间': 'Recharge Time',
  '充值后余额': 'Balance After Recharge',
  '费用明细': 'Transaction Details',
  '账单管理': 'Statements',
  '费用汇总': 'Fee Summary',
  '费用': 'Fees',
  '金额': 'Amount',
  '变动金额': 'Change Amount',
  '变动后余额': 'Balance After Change',
  '操作人': 'Operator',
  '发生时间': 'Transaction Time',
  '备注': 'Remarks',
  '加价': 'Markup',
  '加价比例': 'Markup Rate',
  '加价金额': 'Markup Amount',
  '加价利润': 'Markup Profit',
  '成本': 'Cost',
  '客户收费': 'Customer Charge',
  '上游预估成本': 'Estimated Provider Cost',
  '数量': 'Quantity',
  '按日': 'Daily',
  '按月': 'Monthly',
  '期间': 'Period',
  '开始日期': 'Start Date',
  '结束日期': 'End Date',
  '账户余额': 'Account Balance',
  '客户账户': 'Customer Accounts',
  '客户账户读取失败': 'Failed to load customer accounts',
  '筛选范围': 'Selected Range',
  '充值总额 (USD)': 'Total Recharge (USD)',
  '充值总额(USD)': 'Total Recharge (USD)',
  '变动前 (USD)': 'Balance Before (USD)',
  '变动前(USD)': 'Balance Before (USD)',
  '变动后 (USD)': 'Balance After (USD)',
  '变动后(USD)': 'Balance After (USD)',
  '变动后押金 (USD)': 'Deposit After Change (USD)',
  '变动后账户金额 (USD)': 'Account Balance After (USD)',
  '变动后账户金额(USD)': 'Account Balance After (USD)',
  '变动金额(USD)': 'Change Amount (USD)',
  '已补押金 (USD)': 'Deposit Replenished (USD)',
  '当前押金 (USD)': 'Current Deposit (USD)',
  '待补押金 (USD)': 'Deposit Shortfall (USD)',
  '扣取押金 (USD)': 'Deposit Deduction (USD)',
  '目标押金 (USD)': 'Target Deposit (USD)',
  '账单金额 (USD)': 'Statement Amount (USD)',
  '美元兑人民币汇率（1 USD = ? CNY）': 'USD to CNY Rate (1 USD = ? CNY)',
  '可用余额 = 当前余额 - 冻结金额。订单创建后冻结费用，生成账单时正式扣除；订单删除或预报失败时隔天释放。充值会先补足押金缺口，剩余金额进入余额。': 'Available balance = current balance - frozen amount. Order charges are frozen when an order is created and deducted when billed. Frozen charges are released the next day after deletion or submission failure. Recharges first cover the deposit shortfall, and the remainder is credited to the balance.',
  '首次充值金额将作为该客户的目标押金，后续充值只补足与此目标的差额。': 'The first recharge sets the customer’s target deposit. Later recharges only cover the difference to that target.',

  // Claims, deposits, contacts and notices
  '提交索赔': 'Submit Claim',
  '索赔管理': 'Claims',
  '索赔类型': 'Claim Type',
  '索赔状态': 'Claim Status',
  '索赔金额': 'Claim Amount',
  '索赔单号': 'Claim No.',
  '关联订单': 'Related Order',
  '更换订单': 'Change Order',
  '请选择要申请争议的订单': 'Select an order for this dispute',
  '扣取押金': 'Deduct Deposit',
  '扣取金额': 'Deduction Amount',
  '扣款记录': 'Deduction Records',
  '扣款凭证': 'Deduction Evidence',
  '上传附件': 'Upload Attachment',
  '查看附件': 'View Attachment',
  '处理说明': 'Processing Notes',
  '常用联系人': 'Contacts',
  '联系人类型': 'Contact Type',
  '公告': 'Announcement',
  '消息': 'Message',
  '未读': 'Unread',
  '待办事项': 'To-do Items',
  '需要关注的业务': 'Items requiring attention',
  '快捷操作': 'Quick Actions',
  '系统能力': 'System Capabilities',
  '订单统计': 'Order Statistics',
  '本期余额': 'Current Period Balance',
  '最近订单': 'Recent Orders',

  // Common status and messages
  '全部': 'All',
  '全部客户': 'All Customers',
  '全部类型': 'All Types',
  '全部状态': 'All Statuses',
  '启用': 'Enabled',
  '禁用': 'Disabled',
  '处理中': 'Processing',
  '待处理': 'Pending',
  '待确认': 'Pending Confirmation',
  '待核对': 'Pending Review',
  '成功': 'Success',
  '失败': 'Failed',
  '预报成功': 'Shipment Submitted',
  '预报失败': 'Shipment Failed',
  '待平台确认': 'Awaiting Provider Confirmation',
  '订单已删除': 'Order deleted',
  '订单已恢复': 'Order restored',
  '操作成功': 'Operation completed',
  '操作失败': 'Operation failed',
  '数据加载失败': 'Failed to load data',
  '暂无数据': 'No data',
  '请稍后重试': 'Please try again later',
  '请联系管理员': 'Please contact an administrator',
  '请选择': 'Please select',
  '请输入': 'Please enter',
  '搜索': 'Search',
  '上传': 'Upload',
  '预览': 'Preview',
  '确认删除': 'Confirm deletion',
  '确认恢复': 'Confirm restoration'
}

// Phrases returned by forms, validation rules and provider-facing workflows.
// These are kept separately so the common navigation dictionary stays easy to review.
Object.assign(translations, {
  // Dynamic menu labels and provider values returned by the API.
  '首页': 'Home',
  '选择': 'Select',
  '共 ': 'Total ',
  ' 件，': ' pieces, ',
  ' 个产品': ' products',
  '网站管理': 'Website Management',
  '系统管理': 'System Management',
  '系统监控': 'System Monitoring',
  '日志管理': 'Log Management',
  '数据分析': 'Analytics',
  '客户门户': 'Customer Portal',
  '操作': 'Actions',
  '操作模块': 'Operation Module',
  '操作内容': 'Operation Details',
  '操作类型': 'Operation Type',
  '操作用户': 'Operator',
  '操作地址': 'Operation Location',
  '请求耗时': 'Request Duration',
  '正常': 'Normal',
  '其他操作': 'Other',
  '下线': 'Sign Out User',
  '美东': 'US East',
  '美中': 'US Central',
  '美西': 'US West',
  '美国': 'United States',
  '中国': 'China',

  // Common server-side messages and validation responses.
  '系统提示': 'System Notice',
  '通知': 'Notice',
  '押金通知': 'Deposit Notification',
  '重新登录': 'Sign in again',
  '会话已过期，请重新登录': 'Your session has expired. Please sign in again.',
  '系统接口请求超时': 'The request timed out. Please try again.',
  '登录状态已过期，请重新登录': 'Your session has expired. Please sign in again.',
  '长时间未操作，已自动退出，请重新登录': 'You were signed out after a period of inactivity. Please sign in again.',
  '无权限使用 API': 'You do not have permission to use this API',
  '无权限使用API': 'You do not have permission to use this API',
  '接口未配置': 'The API is not configured',
  '相关接口未配置': 'The provider API is not configured',
  '相关接口未配置，请联系管理员检查接口凭证': 'The provider API is not configured. Contact an administrator.',
  '相关接口认证请求失败，请检查接口地址与凭证': 'Provider API authentication request failed. Check the API URL and credentials.',
  '相关接口认证失败，请检查接口凭证': 'Provider API authentication failed. Check the API credentials.',
  '相关接口请求参数序列化失败': 'Failed to serialize provider API request parameters',
  '相关接口产品同步失败：': 'Provider product synchronization failed: ',
  '相关接口产品数据格式不正确，请稍后重试': 'The provider product data is invalid. Please try again later.',
  '相关接口试算失败：': 'Provider rate quote failed: ',
  '相关接口返回的运费必须大于0': 'The provider API freight must be greater than 0',
  '相关接口产品不存在': 'The provider product does not exist',
  '相关接口未返回响应': 'The provider API did not respond',
  '相关接口未返回报价币种': 'The provider API did not return a quote currency',
  '未能核实相关接口订单详情，本地订单未更新': 'The provider order details could not be verified. The local order was not updated.',
  '相关接口账单暂不可用，请稍后重试；本地资金账单不受影响': 'The provider billing data is temporarily unavailable. Local account records remain available.',
  '相关接口账单明细查询失败：': 'Provider billing detail query failed: ',
  '参数不能为空': 'Parameters are required',
  '数据不能为空': 'Data is required',
  '请求参数错误': 'Invalid request parameters',
  '请求失败': 'Request failed',
  '失败': ' failed',
  '成功': ' successful',
  '不存在': ' does not exist',
  '未配置': ' is not configured',
  '未找到': ' not found',
  '已存在': ' already exists',
  '已过期': ' has expired',
  '无效': 'Invalid ',
  '不足': ' insufficient',
  '超时': ' timed out',
  '请稍后重试': 'Please try again later',
  '请联系管理员': 'Please contact an administrator',
  '操作失败': 'Operation failed',
  '操作成功': 'Operation completed',
  '保存失败': 'Save failed',
  '保存成功': 'Saved successfully',
  '删除成功': 'Deleted successfully',
  '新增成功': 'Added successfully',
  '修改成功': 'Updated successfully',
  '上传成功': 'Uploaded successfully',
  '上传失败': 'Upload failed',
  '导出失败': 'Export failed',
  '查询失败': 'Query failed',
  '加载失败': 'Load failed',
  '数据加载失败': 'Failed to load data',
  '用户名不存在': 'Username does not exist',
  '用户名或密码错误': 'Invalid username or password',
  '登录失败次数过多，请15分钟后重试': 'Too many failed sign-in attempts. Try again in 15 minutes.',
  '登录目标或账号角色无效': 'The login target or account role is invalid',
  '客户账号不能登录管理后台': 'Customer accounts cannot sign in to the administrator console',
  '只有客户账号可以登录客户门户': 'Only customer accounts can sign in to the customer portal',
  '账号已被禁用': 'This account has been disabled',
  '账号被禁用，请联系管理员': 'This account has been disabled. Please contact an administrator.',
  '账号不存在': 'Account does not exist',
  '验证码错误': 'Invalid captcha',
  '验证码已过期': 'Captcha has expired',
  '请选择': 'Please select',
  '请输入': 'Please enter',
  '不能为空': ' is required',
  '产品编码不能为空': 'Product code is required',
  '下单用户不能为空': 'Ordering user is required',
  '用户不能为空': 'User is required',
  '产品不存在或未启用': 'The product does not exist or is disabled',
  '所选产品暂不可下单': 'The selected product is not available for ordering',
  '所选产品暂无可用运费': 'No freight is available for the selected product',
  '所选产品暂无可用运费': 'No freight is available for the selected product',
  '所选产品不可用': 'The selected product is unavailable',
  '请先从相关接口同步产品，再配置加价比例': 'Synchronize provider products before configuring a markup rate',
  '请先在产品下拉中选择至少一个产品': 'Select at least one product from the product list',
  '运费试算暂不可用，请稍后重试': 'Rate quoting is temporarily unavailable. Please try again later.',
  '运费试算暂不可用，请重试当前产品': 'Rate quoting is temporarily unavailable. Retry this product.',
  '运费试算请求超时，请重试当前产品': 'The rate request timed out. Retry this product.',
  '运费报价已变化，请重新试算后确认下单': 'The rate quote has changed. Quote again before confirming the order.',
  '该产品暂不支持美元结算': 'This product does not support USD settlement',
  '该产品暂无可用运费': 'No freight is available for this product',
  '仅支持美元充值': 'Only USD recharges are supported',
  '美元直接充值不支持手续费或汇率参数': 'Direct USD recharge does not support fee or exchange-rate parameters',
  '订单预报成功，费用已冻结': 'Shipment submitted; order funds are frozen',
  '格式不正确': ' has an invalid format',

  // Dashboard and shared layout phrases
  '你好，': 'Hello, ',
  '这里是你的物流业务概览。': 'Here is your logistics business overview.',
  '待办事项': 'To-do Items',
  '需要关注的订单': 'Orders that need attention',
  '待确认订单': 'Orders awaiting confirmation',
  '处理中订单': 'Orders in progress',
  '待核对订单': 'Orders requiring review',
  '待出账订单': 'Orders awaiting billing',
  '待缴费押金': 'Deposit due',
  '待处理索赔': 'Claims pending processing',
  '待处理争议': 'Disputes pending processing',
  '查看全部消息': 'View all messages',
  '快捷操作': 'Quick Actions',
  '常用功能': 'Common Functions',
  '查看更多': 'View More',
  '查看资金账户': 'View Account',
  '账户余额': 'Account Balance',
  '近30天': 'Last 30 Days',
  '订单总数': 'Total Orders',
  '订单数': 'Order Count',
  '票数': 'Shipments',
  '最近订单': 'Recent Orders',
  '条未读': ' unread',
  '知道了': 'Got it',
  '登录时间：': 'Login time: ',
  '登录IP：': 'Login IP: ',
  '系统能力': 'System Capabilities',
  '用户与角色': 'Users and Roles',
  '菜单与按钮权限': 'Menu and Button Permissions',
  '按角色配置菜单和操作权限': 'Configure menus and actions by role',
  '发布和查看系统通知': 'Publish and view system notices',
  '统一管理系统文件和附件': 'Manage system files and attachments',
  '记录用户登录和操作行为': 'Record user logins and actions',
  '维护用户、角色及数据权限': 'Maintain users, roles and data permissions',
  '维护字典、参数和运行配置': 'Maintain dictionaries, parameters and runtime settings',
  '近七日操作量': 'Operations in the Last Seven Days',
  '用户数量': 'Users',
  '角色数量': 'Roles',
  '菜单数量': 'Menus',
  '今日操作数': 'Operations Today',
  '操作量': 'Operations',
  '个人中心': 'Profile',
  '主题风格设置': 'Theme Settings',
  '系统布局配置': 'Layout Settings',
  '系统主题色': 'Theme Color',
  '主题颜色': 'Theme Color',
  '侧边栏主题': 'Sidebar Theme',
  '标签页主题': 'Tabs Theme',
  '开启标签页': 'Enable Tabs',
  '固定导航栏': 'Fixed Navigation',
  '固定顶部导航栏': 'Fixed Top Navigation',
  '显示 Logo': 'Show Logo',
  '保存配置': 'Save Settings',
  '重置配置': 'Reset Settings',
  '关闭当前': 'Close Current',
  '关闭其他': 'Close Others',
  '关闭全部': 'Close All',
  '关闭左侧': 'Close Left',
  '关闭右侧': 'Close Right',
  '刷新当前页面': 'Refresh Current Page',

  // Order detail and provider response fields
  '基本信息': 'Basic Information',
  '订单记录': 'Order Records',
  '订单件数': 'Order Pieces',
  '运单号码：': 'Waybill No.: ',
  '订单号码：': 'Order No.: ',
  '子单号码': 'Sub-order No.',
  '子单参考号': 'Sub-order Reference',
  '查看子单信息': 'View Sub-order Details',
  '出账状态': 'Billing Status',
  '出账件数': 'Billed Pieces',
  '平台主状态码': 'Provider Status Code',
  '平台状态更新': 'Provider Status Update',
  '处理提示：': 'Processing note: ',
  '平台实时详情暂未读取成功，当前显示下单时保存的信息。可点击刷新重试。': 'The latest provider details are unavailable. Information saved at order creation is shown. Refresh to retry.',
  '平台暂无轨迹记录': 'The provider has no tracking records yet',
  '当前接口未标明每条轨迹对应的子单。': 'The API does not identify the sub-order for each tracking event.',
  '平台暂未返回子单信息': 'The provider has not returned sub-order details',
  '暂无 Invoice 信息': 'No invoice information',
  '暂无包裹明细': 'No package details',
  '地址信息': 'Address Information',
  '地址2': 'Address 2',
  '公司': 'Company',
  '国家': 'Country',
  '州省': 'State/Province',
  '城市': 'City',
  '电话': 'Phone',
  '邮箱': 'Email',
  '邮编': 'ZIP Code',
  '联系人': 'Contact',
  '商品名称': 'Item Name',
  '单价': 'Unit Price',
  '总价': 'Total Price',
  '净重': 'Net Weight',
  '原产地': 'Country of Origin',
  '海关编码': 'HS Code',
  '账单分区': 'Billing Zone',
  '分区': 'Zone',
  '偏远地区': 'Remote Area',
  '偏远等级': 'Remote Area Level',
  '自动生成': 'Auto-generated',

  // Quote and package workflow
  '输入产品编码': 'Enter product code',
  '选择产品': 'Select Product',
  '选择最低价产品': 'Select Lowest-priced Product',
  '所选产品不可用，请刷新产品列表': 'The selected product is unavailable. Refresh the product list.',
  '增加': 'Add',
  '切换重量单位至 ': 'Switch weight unit to ',
  '切换尺寸单位至 ': 'Switch dimension unit to ',
  '费用说明': 'Fee Details',
  '查看费用说明': 'View Fee Details',
  '附加项目（仅供参考）：': 'Additional items (for reference only):',
  '暂无附加项目明细': 'No additional item details',
  '暂无可用报价': 'No quotes available',
  '正在请求中，请稍后': 'Requesting, please wait',
  '重试': 'Retry',
  '普通偏远': 'Standard Remote Area',
  '超偏远': 'Very Remote Area',
  '超超偏远': 'Extremely Remote Area',
  '住宅地址': 'Residential Address',
  '试算时自动保存联系人和包裹信息；包裹信息变更后需重新试算': 'Contacts and packages are saved automatically when quoting. Quote again after changing package details.',
  '联系人信息已保存到常用联系人': 'Contact details saved to saved contacts',
  '联系人自动保存失败，请稍后重试': 'Could not save contact details automatically. Please try again later.',
  '若为住宅地址，将在试算费用基础上额外收取住宅地址费用，请悉知。': 'For residential addresses, an additional residential address fee will be charged on top of the quoted amount. Please be aware.',
  '平台累计充值': 'Total Platform Top-ups',
  '所有用户实际充入余额的累计金额，已扣除充值撤销的余额部分；不含押金，不随客户筛选变化。': 'Actual wallet top-ups across all users, less wallet recharge reversals. Excludes deposits and is independent of customer selection.',
  '充值金额必须为正整数美元': 'Top-ups must be a positive whole number of USD',
  '读取失败，点击重试': 'Failed to load. Click to retry',
  '住宅': 'Residential',
  '燃油类别': 'Fuel Type',
  '起运港：': 'Origin port: ',
  '目的港：': 'Destination port: ',
  '预计到达：': 'Estimated arrival: ',
  '目的地国家代码': 'Destination Country Code',
  '目的地国家代码应为两位英文字母': 'The destination country code must contain two letters',

  // Finance, claims and recycle bin workflow
  '当前查询统计': 'Current Results',
  '筛选范围增加 ': 'Increases in selected range ',
  '筛选范围减少 ': 'Decreases in selected range ',
  '筛选范围充值合计 ': 'Recharge total in selected range ',
  '有出账记录订单 ': 'Orders with billing records ',
  '选择客户后可更新出账记录': 'Select a customer to update billing records',
  '期间对账（全部类型） ': 'Period reconciliation (all types) ',
  '期间对账单-USD-': 'Period statement - USD -',
  '填写本次充值说明（选填）': 'Enter a recharge note (optional)',
  '充值成功，入账 ': 'Recharge successful. Credited ',
  '扣费，确认提交？': 'Charge and submit?',
  '订单确认成功后转为扣费，失败后释放。': 'The amount is charged after confirmation and released on failure.',
  '外部接口未确认受理订单，请人工核对': 'The external API did not confirm acceptance. Please review manually.',
  '外部接口返回的参考编号与本次订单不一致，请人工核对': 'The reference returned by the external API does not match this order. Please review manually.',
  '外部接口未返回订单 ID，请人工核对': 'The external API did not return an order ID. Please review manually.',
  '订单预报成功后才能获取面单': 'The label is available only after shipment submission succeeds',
  '面单暂时无法获取，请稍后重试': 'The label is temporarily unavailable. Please try again later.',
  '面单地址不可访问': 'The label URL is not accessible',
  '面单文件暂时无法获取': 'The label file is temporarily unavailable',
  '面单文件超过15MB': 'The label file exceeds 15 MB',
  '面单地址未返回PDF文件': 'The label URL did not return a PDF file',
  '回收站订单不能刷新，请先恢复订单': 'Recycle-bin orders cannot be refreshed. Restore the order first.',
  '订单状态暂时无法更新，请稍后重试': 'The order status cannot be updated yet. Please try again later.',
  '状态接口返回的订单标识与本地订单不一致': 'The order ID returned by the status API does not match the local order',
  '状态接口未返回有效状态码，请人工核对': 'The status API returned no valid status code. Please review manually.',
  '状态接口返回未知状态码，请人工核对': 'The status API returned an unknown status code. Please review manually.',
  '外部状态已成功，但订单详情暂不可用，请人工核对': 'The external status is successful, but order details are unavailable. Please review manually.',
  '订单详情与状态接口不一致，请人工核对': 'Order details do not match the status API. Please review manually.',
  '订单已预报成功，但本地余额不足，请管理员核对': 'The order was submitted successfully, but the local balance is insufficient. Ask an administrator to review it.',
  '订单仍在处理中或待核对，暂不能删除': 'Orders in progress or pending review cannot be deleted yet',
  '订单暂不能删除，请联系管理员': 'This order cannot be deleted yet. Contact an administrator.',
  '原平台已删除，但本地回收站更新失败，请联系管理员核对，勿重复删除': 'The provider order was deleted, but the local recycle bin was not updated. Contact an administrator and do not delete again.',
  '订单状态已变化，请刷新后重试': 'The order status has changed. Refresh and try again.',
  '缺少原平台订单 ID，请联系管理员核对恢复状态': 'The provider order ID is missing. Contact an administrator to verify restoration.',
  '原平台订单尚未恢复，请先联系管理员在原平台恢复后再核实': 'The provider order has not been restored. Ask an administrator to restore it before verifying.',
  '订单处理失败，请联系管理员': 'Order processing failed. Contact an administrator.',
  '订单状态待核对，请联系管理员': 'The order status requires review. Contact an administrator.',
  '扣款后押金 (USD)': 'Deposit After Deduction (USD)',
  '押金操作失败，请查询流水后重试': 'Deposit operation failed. Query transactions and retry.',
  '每笔订单可直接扣取押金，也可查看历史扣款和附件': 'Deduct a deposit directly for each order and view deduction history and attachments',
  '证明附件': 'Supporting Attachment',
  '问题说明': 'Issue Description',
  '处理记录': 'Processing Records',
  '处理时间': 'Processing Time',
  '处理状态': 'Processing Status',
  '索赔详情': 'Claim Details',
  '暂无符合条件的成功订单': 'No successful orders match the criteria',
  '暂无符合条件的订单': 'No orders match the criteria',
  '暂无符合条件的记录': 'No records match the criteria',
  '暂无资金变动记录': 'No account transactions',
  '暂无预报成功的订单': 'No submitted orders',
  '有记录': 'Has Records',
  '未上传': 'Not Uploaded',
  '无附件': 'No Attachment',
  '上传图片或 PDF': 'Upload an image or PDF',
  '下载 PDF': 'Download PDF',
  '下载附件': 'Download Attachment',
  '移除附件': 'Remove Attachment',
  '凭证读取失败': 'Failed to load evidence',
  '联系人保存失败': 'Failed to save contact',
  '调整记录': 'Adjustment Records',
  '调整原因': 'Adjustment Reason',
  '保存处理结果': 'Save Processing Result',
  '平台已删除': 'Deleted on Provider Platform',
  '未恢复的订单仍留在回收站。': 'Orders that are not restored remain in the recycle bin.',
  '请先在原平台恢复该订单。点击“核实恢复”后，系统将查询原平台状态': 'Restore the order on the provider platform first, then click “Verify Restoration” to check its status.',
  '如需恢复请联系管理员。确认删除？': 'Contact an administrator if restoration is needed. Confirm deletion?',
  '预报失败的订单将仅在本系统移入回收站，不影响账户余额。确认删除？': 'Failed shipments are moved to this system’s recycle bin only and do not affect the account balance. Confirm deletion?',

  '下单客户': 'Ordering Customer',
  '选择收件人': 'Select Recipient',
  '选择寄件人': 'Select Sender',
  '保存收件人': 'Save Recipient',
  '保存寄件人': 'Save Sender',
  '刷新联系人': 'Refresh Contacts',
  '粘贴收件信息': 'Paste recipient information',
  '字段之间用逗号分隔': 'Separate fields with commas',
  '请粘贴收件信息': 'Paste recipient information',
  '选择或输入仓库编码': 'Select or enter a warehouse code',
  '请选择客户': 'Select a customer',
  '请选择下单客户': 'Select an ordering customer',
  '请选择下单用户': 'Select an ordering user',
  '请选择目的地': 'Select a destination',
  '请选择发货区域': 'Select a shipping region',
  '请输入或选择收件城市': 'Enter or select a recipient city',
  '请选择密度': 'Select density',
  '请选择订单': 'Select an order',
  '请选择关联订单': 'Select a related order',
  '请选择预报成功的订单': 'Select a submitted order',
  '收起寄件信息': 'Collapse sender information',
  '填写寄件信息': 'Enter sender information',
  '已选': 'Selected',
  '个产品': 'products',
  '清空选择': 'Clear selection',
  '该区域暂无可用产品': 'No products are available for this region',
  '该发货区域暂无可用产品': 'No products are available for this shipping region',
  '可勾选分类或': 'You can select a category or',
  '进行批量试算': 'to quote rates in bulk',
  '提交预报时请在试算结果中选择一个产品': 'Select a product from the quote results before submitting',
  '请先完成运费试算并选择产品': 'Complete the rate quote and select a product first',
  '未收到试算结果': 'No quote result was returned',
  '未收到该产品的试算结果，请重试': 'No quote was returned for this product. Please retry',
  '暂无可用报价，请展开查看': 'No available quote. Expand to view details',
  '多币种，请展开选择': 'Multiple currencies. Expand to choose',
  '客户应付': 'Customer Payable',
  '成本/加价': 'Cost / Markup',
  '总费用': 'Total Charge',
  '产品加价比例': 'Product Markup Rate',
  '加价比例': 'Markup Rate',
  '加价配置': 'Markup Configuration',
  '重置订单': 'Reset Order',
  '订单号码': 'Order No.',
  '订单号码只能包含字母、数字、下划线和减号，最长35位': 'Order No. may contain letters, numbers, underscores and hyphens, up to 35 characters',
  '请增加包裹信息': 'Add package information',
  '请填写': 'Please enter ',
  '请填写第': 'Please complete package ',
  '的件数应为1至999': ': pieces must be between 1 and 999',
  '个包裹的重量和长宽高': 'package weight and dimensions',
  '输入最多三位小数': 'Enter up to three decimal places',
  '换算到接口单位后需大于': 'The converted API value must be greater than ',
  '且不超过': ' and no more than ',
  '收件信息已识别并填入': 'Recipient information was detected and filled in',
  '订单已创建': 'Order created',
  '预报成功，订单费用已冻结': 'Shipment submitted; order funds are frozen',
  '预报失败，冻结金额将在隔天释放': 'Shipment failed; frozen funds will be released the next day',
  '预报已确认，订单费用保持冻结，生成账单后正式扣除': 'Shipment confirmed; order funds remain frozen until billing',
  '订单仍在处理中，费用保持冻结': 'The order is still processing; order funds remain frozen',
  '订单待核对，费用保持冻结': 'The order requires review; order funds remain frozen',
  '当前显示最近更新的订单信息，请稍后再刷新': 'Showing the most recently updated order data. Please refresh later',
  '请稍后在订单管理刷新状态': 'Refresh the status later in Order Management',
  '勿重复提交': 'Do not submit again',
  '账户可用余额不足': 'Insufficient available balance',
  '账户可用余额不足：本次需': 'Insufficient available balance. Required: ',
  '当前可用': 'Available: ',
  '请联系管理员充值美元余额': 'Please ask an administrator to recharge the USD balance',
  '本次需': 'Required: ',
  '当前可用余额': 'Available balance: ',
  '请人工核对': 'Please review manually',
  '请联系管理员充值美元余额后再提交': 'Ask an administrator to recharge the USD balance before submitting',
  '订单查询失败': 'Failed to query orders',
  '订单列表读取失败': 'Failed to load the order list',
  '订单详情读取失败': 'Failed to load order details',
  '子单信息读取失败': 'Failed to load package details',
  '运单轨迹读取失败': 'Failed to load shipment tracking',
  '订单状态查询失败': 'Failed to query order status',
  '订单状态暂时无法同步': 'Order status cannot be synchronized yet',
  '订单已刷新': 'Orders refreshed',
  '订单信息已更新': 'Order information updated',
  '同步当前页订单状态及出账记录': 'Synchronize order status and billing records on this page',
  '已同步平台订单状态': 'Provider order status synchronized',
  '订单已移入回收站': 'Order moved to the recycle bin',
  '删除后订单将进入回收站': 'Deleted orders will be moved to the recycle bin',
  '请联系管理员进行恢复': 'Contact an administrator for restoration',
  '如需恢复请联系管理员': 'Contact an administrator if restoration is needed',
  '订单已恢复到订单列表': 'Order restored to the order list',
  '平台已删除': 'Deleted on provider platform',
  '本地归档': 'Local archive',
  '号码查询': 'Number Search',
  '号码类型': 'Number Type',
  '搜索订单号码': 'Search order number',
  '搜索订单号': 'Search order number',
  '订单列表已更新': 'Order list updated',
  '查看押金扣款记录': 'View deposit deduction records',
  '暂无押金扣款记录': 'No deposit deduction records',
  '该订单暂无押金扣款记录': 'This order has no deposit deduction records',
  '押金扣款记录读取失败': 'Failed to load deposit deduction records',
  '扣取押金': 'Deduct Deposit',
  '确认本次押金扣款': 'Confirm this deposit deduction',
  '扣取金额必须大于': 'Deduction amount must be greater than ',
  '押金已扣取': 'Deposit deducted',
  '客户将收到通知': 'The customer will be notified',
  '并向客户发送通知': 'and notify the customer',
  '扣款成功后会记录资金流水': 'A transaction record will be created after the deduction succeeds',
  '扣款凭证预览': 'Deduction evidence preview',
  '可用于留存扣款依据': 'May be retained as deduction evidence',
  '充值登记': 'Recharge Entry',
  '确认充值': 'Confirm Recharge',
  '确认向': 'Confirm recharge for ',
  '充值成功': 'Recharge successful',
  '充值失败': 'Recharge failed',
  '充值金额必须大于': 'Recharge amount must be greater than ',
  '充值金额超出页面支持的精度': 'Recharge amount exceeds the supported precision',
  '请查询流水后重试': 'Query the transaction records and retry',
  '资金流水读取失败': 'Failed to load transaction records',
  '最近变动读取失败': 'Failed to load recent transactions',
  '账单查询失败': 'Failed to query statements',
  '利润统计读取失败': 'Failed to load profit statistics',
  '索赔列表读取失败': 'Failed to load claims',
  '索赔详情读取失败': 'Failed to load claim details',
  '索赔已保存': 'Claim saved',
  '索赔提交失败': 'Failed to submit claim',
  '请填写问题说明': 'Enter a problem description',
  '请选择关联订单': 'Select a related order',
  '联系人已保存': 'Contact saved',
  '联系人已删除': 'Contact deleted',
  '联系人读取失败': 'Failed to load contacts',
  '保存联系人失败': 'Failed to save contact',
  '产品加价配置已保存': 'Product markup saved',
  '保存产品加价配置失败': 'Failed to save product markup',
  '（可跨页勾选）': '(selection is kept across pages)',
  '批量配置产品加价': 'Bulk Product Markup',
  '批量配置': 'Bulk Configure',
  '当前产品': 'Selected Product',
  '启用中': 'Active',
  '已停用': 'Inactive',
  '产品状态': 'Product Status',
  '启用，客户可选择此产品': 'Active: customers can select this product',
  '停用，客户不可选择此产品': 'Inactive: customers cannot select this product',
  '0% 表示按原价展示；历史订单仍使用下单时的比例。': '0% shows the original rate. Existing orders retain their original markup.',
  '0% 表示不加价；只影响后续试算和下单。': '0% adds no markup. Changes apply only to future quotes and orders.',
  '可填写本次调整说明': 'Optional reason for this change',
  '可填写本次批量调整说明': 'Optional reason for this bulk change',
  '保存配置': 'Save Configuration',
  '将统一配置': 'Set the same markup for',
  '所选产品可以来自不同页；保存后逐个保留调整记录。': 'Selected products may span pages. Each changed rate is recorded separately.',
  '统一加价比例': 'Markup Rate for All Selected Products',
  '保持不变': 'Keep Current Status',
  '全部启用': 'Activate All',
  '全部停用': 'Deactivate All',
  '确认配置': 'Apply Configuration',
  '请先勾选要配置的产品': 'Select products to configure first',
  '单次最多配置500个产品': 'Select no more than 500 products at a time',
  '单次请选择1至500个产品': 'Select 1 to 500 products',
  '加价比例请输入0至1000之间的数值，最多两位小数': 'Enter a markup rate from 0 to 1000% with up to two decimal places',
  '批量配置失败': 'Bulk configuration failed',
  '已配置': 'Configured',
  '其中': 'including',
  '个产品的加价比例发生变化': 'products with a changed markup rate',
  '相关接口产品同步完成': 'Provider products synchronized',
  '相关接口产品同步失败': 'Failed to synchronize provider products',
  '同步相关接口产品': 'Sync Provider Products',
  '相关接口': 'Provider API',
  '导入记录': 'Import History',
  '账单导入记录': 'Billing Import History',
  '返回批次': 'Back to Batches',
  '文件 SHA-256': 'File SHA-256',
  'Excel 行': 'Excel Row',
  '上次出账': 'Previous Billing',
  '本次出账': 'Current Billing',
  '差额': 'Difference',
  '处理状态': 'Processing Status',
  '总行数': 'Total Rows',
  '导入时间': 'Imported At',
  '导入记录加载失败': 'Failed to load import history',
  '导入明细加载失败': 'Failed to load import details',
  '账单 Excel 不能超过10MB': 'The billing workbook must be 10 MB or smaller',
  '单次最多导入10000行账单': 'Import no more than 10,000 billing rows at a time',
  '账单文件校验失败': 'Failed to verify the billing workbook',
  '合计金额最多保留两位小数': 'The total amount may have no more than two decimal places',
  '合计金额超过系统支持的最大金额': 'The total amount exceeds the supported limit',
  '订单匹配结果已变化，请重新导入': 'The order match changed. Please import the workbook again.',
  '单个凭证不能超过': 'Each piece of evidence must not exceed ',
  '单个附件不能超过': 'Each attachment must not exceed ',
  '凭证已上传': 'Evidence uploaded',
  '附件已上传': 'Attachment uploaded',
  '凭证上传失败': 'Failed to upload evidence',
  '附件上传失败': 'Failed to upload attachment',
  '面单暂时无法预览': 'Label preview is temporarily unavailable',
  '面单暂时无法下载': 'Label download is temporarily unavailable',
  '面单尚未生成': 'The label has not been generated yet',
  '运输途中': 'In transit',
  '派件中': 'Out for delivery',
  '已签收': 'Delivered',
  '代理已提取': 'Picked up by agent',
  '已结案': 'Closed',
  '已驳回': 'Rejected',
  '破损': 'Damaged',
  '延误': 'Delayed',
  '丢失': 'Lost',
  '暂无数据': 'No data',
  '暂无明细': 'No details',
  '暂无公告': 'No announcements',
  '暂无系统公告': 'No system announcements',
  '暂无消息通知': 'No message notifications',
  '暂无消息内容': 'No messages',
  '请稍后再刷新': 'Please refresh again later',
  '请重新选择后操作': 'Make a new selection and try again',
  '当前订单信息不完整': 'The current order information is incomplete',
  '当前浏览器不支持安全的资金操作': 'This browser does not support secure financial operations',
  '请使用新版浏览器': 'Please use a modern browser',
  '查询条件': 'Search Criteria',
  '重置条件': 'Reset Criteria',
  '导出当前页': 'Export Current Page',
  '导出明细': 'Export Details',
  '导出对账单': 'Export Statement',
  '期间对账': 'Period Reconciliation',
  '期间对账单': 'Period Statement',
  '最近充值记录': 'Recent Recharge Records',
  '最近变动': 'Recent Transactions',
  '上期余额': 'Opening Balance',
  '期初余额': 'Opening Balance',
  '期末余额': 'Closing Balance',
  '订单消费': 'Order Debit',
  '订单退回': 'Order Refund',
  '出账记录': 'Billing Records',
  '未出账子单': 'Unbilled Packages',
  '原始运费': 'Original Freight',
  '实际运费': 'Actual Freight',
  '订单扣费': 'Order Debit',
  '收取押金': 'Deposit Credit',
  '退还押金': 'Deposit Return',
  '扣取押金': 'Deposit Debit',
  '状态': 'Status',
  '创建时间': 'Created At',
  '更新时间': 'Updated At',
  '操作时间': 'Operation Time',
  '登录编号': 'Login ID',
  '用户名称': 'Username',
  '登录IP': 'Login IP',
  '登录位置': 'Login Location',
  '浏览器版本': 'Browser Version',
  '操作系统': 'Operating System',
  '登录状态': 'Login Status',
  '登录提示': 'Login Message',
  '任务名称': 'Job Name',
  '任务分组': 'Job Group',
  '调用目标': 'Invocation Target',
  '执行状态': 'Execution Status',
  '执行时间': 'Execution Time',
  '字典名称': 'Dictionary Name',
  '字典类型': 'Dictionary Type',
  '字典状态': 'Dictionary Status',
  '角色名称': 'Role Name',
  '角色标识': 'Role Key',
  '角色描述': 'Role Description',
  '菜单名称': 'Menu Name',
  '菜单状态': 'Menu Status',
  '访问路径': 'Path',
  '组件路径': 'Component Path',
  '资源名称': 'Resource Name',
  '资源描述': 'Resource Description',
  '请求方式': 'Request Method',
  '请求路径': 'Request Path',
  '用户名': 'Username',
  '用户昵称': 'Nickname',
  '用户头像': 'Avatar',
  '昵称': 'Nickname',
  '头像': 'Avatar',
  '角色': 'Role',
  '普通客户': 'Standard Customer',
  '是': 'Yes',
  '否': 'No',
  '权限管理': 'Permission Management',
  '展开': 'Expand',
  '重置密码': 'Reset Password',
  '请选择用户状态': 'Select user status',
  '用户状态': 'User Status',
  '未分配': 'Unassigned',
  '停用': 'Disabled',
  '电话号码': 'Phone Number',
  '请绑定电话号码': 'Enter phone number',
  '请输入用户昵称': 'Enter nickname',
  '请输入至少6位初始密码': 'Enter an initial password of at least 6 characters',
  '请输入备注': 'Enter remarks',
  '初始密码至少需要6位': 'The initial password must be at least 6 characters',
  '用户昵称不能为空': 'Nickname is required',
  '用户状态不能为空': 'User status is required',
  '新增用户': 'Add User',
  '更新用户': 'Edit User',
  '密码重置成功': 'Password reset successfully',
  '用户状态修改成功': 'User status updated',
  '用户更新成功': 'User updated',
  '用户添加成功': 'User added',
  '正在加载用户信息': 'Loading user details',
  '正在加载表格数据': 'Loading table data',
  '是否确认删除选中的用户数据？': 'Delete the selected users?',
  '手机号码': 'Phone Number',
  '初始密码': 'Initial Password',
  '普通角色': 'Standard User',
  '超级管理员': 'Super Administrator',
  '客户用户': 'Customer User'
})

Object.assign(translations, {
  // Notices and account pages
  '通知与公告': 'Notices and Announcements',
  '公告列表': 'Announcement List',
  '公告标题': 'Announcement Title',
  '公告类型': 'Announcement Type',
  '公告状态': 'Announcement Status',
  '公告内容': 'Announcement Content',
  '请输入公告标题': 'Enter an announcement title',
  '请选择公告类型': 'Select an announcement type',
  '正在加载通知公告信息': 'Loading announcement details',
  '资金账户': 'Account Balance',
  '预扣费': 'Pending Charge',
  '修改密码': 'Change Password',
  '当前密码': 'Current Password',
  '新密码': 'New Password',
  '确认新密码': 'Confirm New Password',
  '请输入当前密码': 'Enter current password',
  '请输入 6-20 位新密码': 'Enter a new password of 6–20 characters',
  '请再次输入新密码': 'Enter the new password again',
  '确认修改': 'Confirm Change',
  '个人信息': 'Personal Information',
  '信息绑定': 'Contact Information',
  '暂未绑定手机': 'No phone number linked',
  '用户名：': 'Username:',
  '昵称：': 'Nickname:',
  '角色：': 'Role:',
  '手机：': 'Phone:',
  '备注：': 'Remarks:',
  '登录地址：': 'Login Address:',
  '登录设备：': 'Login Device:',
  '这里输入备注': 'Enter remarks here',
  // Shipping, billing, claims and disputes
  '重置筛选': 'Reset Filters',
  '地址': 'Address',
  '类型': 'Type',
  '时间': 'Time',
  '说明': 'Description',
  '默认': 'Default',
  '附件': 'Attachment',
  '照片': 'Photo',
  '文件': 'File',
  '选填': 'Optional',
  '暂无': 'None',
  '详情': 'Details',
  '恢复': 'Restore',
  '更新': 'Update',
  '错误': 'Error',
  '日期时间': 'Date and Time',
  '位置': 'Location',
  '目的地': 'Destination',
  '姓名': 'Name',
  '姓名/公司': 'Name / Company',
  '国家代码': 'Country Code',
  '州/省': 'State / Province',
  '币种': 'Currency',
  '减少': 'Decrease',
  '超额': 'Overage',
  '证据': 'Evidence',
  '争议管理': 'Dispute Management',
  '争议类型': 'Dispute Type',
  '争议状态': 'Dispute Status',
  '争议单号': 'Dispute Number',
  '争议单号 / 订单号码 / 运单号码': 'Dispute / Order / Waybill Number',
  '争议信息': 'Dispute Details',
  '争议内容': 'Dispute Content',
  '争议说明': 'Dispute Description',
  '争议证明照片': 'Dispute Evidence Photos',
  '申请争议': 'Submit Dispute',
  '处理争议': 'Process Dispute',
  '关联子单号': 'Related Package Numbers',
  '子单号': 'Package Number',
  '获取子单号': 'Load Package Numbers',
  '上传照片': 'Upload Photos',
  '查看照片': 'View Photos',
  '照片预览': 'Photo Preview',
  '选择订单': 'Select an Order',
  '下单时间': 'Order Date',
  '申请时间': 'Submitted At',
  '简要描述争议原因或期望的处理结果': 'Briefly describe the dispute and your expected resolution',
  '请填写给客户的处理说明': 'Enter the resolution to send to the customer',
  '按订单提交费用或地址争议，处理进度和凭证均可追溯。': 'Submit a charge or address dispute for an order. You can track its progress and evidence.',
  '1.收件信息': '1. Recipient Information',
  '2.产品信息': '2. Product Information',
  '3.包裹信息': '3. Package Information',
  '3.1试算结果': '3.1 Quote Results',
  '提交预报时自动保存': 'Saved automatically when you submit the order',
  '可勾选分类或“全部产品”进行批量试算；提交预报时请在试算结果中选择一个产品。': 'Select a category or All Products for batch quotes, then choose one product before submitting the order.',
  '账单状态': 'Billing Status',
  '待出账': 'Pending Billing',
  '已出账': 'Billed',
  '账单补扣': 'Additional Billing Charge',
  '押金不足': 'Insufficient Deposit',
  '押金变动': 'Deposit Change',
  '押金扣取': 'Deposit Deduction',
  '押金余额': 'Deposit Balance',
  '押金扣款记录': 'Deposit Deduction History',
  '已扣押金': 'Deposit Deducted',
  '待补金额': 'Outstanding Amount',
  '客户已收': 'Collected from Customer',
  '客户实付': 'Paid by Customer',
  '当前利润（未出账按预估成本）': 'Current Profit (estimated cost for unbilled orders)',
  '平台预估成本': 'Estimated Provider Cost',
  '平台最终出账金额': 'Final Provider Charge',
  '客户展示出账金额': 'Customer Billing Amount',
  'API原始运费': 'Original API Freight',
  '运单号': 'Waybill Number',
  '运单轨迹': 'Shipment Tracking',
  '轨迹状态': 'Tracking Status',
  '跟踪记录': 'Tracking Events',
  '子单信息': 'Package Details',
  '计费重量': 'Billable Weight',
  '归属用户': 'Account Owner',
  '账号或名称': 'Account or Name',
  '统计粒度': 'Time Grouping',
  '数据类型': 'Data Type',
  '删除时间': 'Deleted At',
  '删除方式': 'Deletion Method',
  '搜索客户': 'Search Customers',
  '同步当前页订单状态': 'Sync Status for Current Page',
  '期间对账（全部类型）': 'Period Reconciliation (All Types)',
  '筛选范围充值合计': 'Total Recharge in Selected Range',
  '筛选范围增加': 'Total Credits in Selected Range',
  '筛选范围减少': 'Total Debits in Selected Range',
  '加价调整记录': 'Markup Change History',
  '当前加价': 'Current Markup',
  '当前生效': 'Currently Active',
  '生效时间': 'Effective At',
  '失效时间': 'Expires At',
  '扣款时间': 'Deducted At',
  '索赔信息': 'Claim Details',
  '货物信息': 'Goods Information',
  '证明照片': 'Evidence Photos',
  '添加图片': 'Add Images',
  '选择关联订单': 'Select Related Order',
  '历史附件': 'Existing Attachments',
  '提交时间': 'Submitted At',
  '快递面单 PDF': 'Shipping Label PDF',
  '快递面单预览': 'Shipping Label Preview',
  '下载原始账单': 'Download Original Statement',
  '返回订单列表': 'Back to Orders',
  '刷新包裹': 'Refresh Packages',
  '已导入平台账单': 'Provider Statement Imported',
  '配置': 'Configure',
  '新增联系人': 'Add Contact',
  '确认扣取': 'Confirm Deduction',
  '关联订单号': 'Related Order Number',
  '收件地址2': 'Recipient Address Line 2',
  '寄件地址2': 'Sender Address Line 2',
  '请输入订单号码': 'Enter order number',
  '请输入号码': 'Enter number',
  '请先选择客户': 'Select a customer first',
  '粘贴收件信息，支持逗号、双空格或换行分隔': 'Paste recipient details separated by commas, double spaces or line breaks'
})

Object.assign(translations, {
  '充值金额 (USD)': 'Recharge Amount (USD)',
  '客户已收 (USD)': 'Collected from Customer (USD)',
  '当前利润 (USD)': 'Current Profit (USD)',
  '平台预估成本 (USD)': 'Estimated Provider Cost (USD)',
  '平台最终出账金额 (USD)': 'Final Provider Charge (USD)',
  '账单补扣 (USD)': 'Additional Billing Charge (USD)',
  '待补金额 (USD)': 'Outstanding Amount (USD)',
  '押金扣取 (USD)': 'Deposit Deduction (USD)',
  '客户实付 (USD)': 'Paid by Customer (USD)',
  '已扣押金 (USD)': 'Deposit Deducted (USD)',
  '当前余额 (USD)': 'Current Balance (USD)',
  '押金 (USD)': 'Deposit (USD)',
  '变动金额 (USD)': 'Transaction Amount (USD)',
  '变动后余额 (USD)': 'Balance After Transaction (USD)',
  '充值后余额 (USD)': 'Balance After Recharge (USD)',
  '上期余额 (USD)': 'Opening Balance (USD)',
  '发生金额 (USD)': 'Transaction Amount (USD)',
  '本期余额 (USD)': 'Closing Balance (USD)',
  '索赔金额 (USD)': 'Claim Amount (USD)',
  '扣取金额 (USD)': 'Deduction Amount (USD)',
  '扣款金额 (USD)': 'Deducted Amount (USD)',
  '产品单价 (USD)': 'Unit Price (USD)',
  '产品总价 (USD)': 'Total Product Value (USD)',
  '产品长 (cm)': 'Product Length (cm)',
  '产品宽 (cm)': 'Product Width (cm)',
  '产品高 (cm)': 'Product Height (cm)',
  '产品名称（英文）': 'Product Name (English)',
  '产品颜色（英文）': 'Product Color (English)',
  '产品材质（英文）': 'Product Material (English)',
  '用途（英文）': 'Intended Use (English)',
  '单件产品数': 'Units per Package',
  '剩余预扣费': 'Remaining Pending Charge',
  '明细': 'Details',
  'Invoice 信息': 'Invoice Information',
  '争议详情': 'Dispute Details',
  '请选择产品': 'Select a product',
  '该区域暂无可用产品': 'No products available for this shipping region',
  '请描述货物问题及希望如何处理': 'Describe the issue with the goods and your preferred resolution',
  '按产品设置，0% 表示按原价展示；历史订单仍使用下单时的比例。': 'Set markup by product. A 0% markup shows the original price. Existing orders retain their markup at the time of ordering.',
  '扣款成功后会记录资金流水，并向客户发送通知。': 'After a successful deduction, the transaction is recorded and the customer is notified.',
  '附件为选填项，可用于留存扣款依据。': 'Attachments are optional and can document the reason for the deduction.',
  '可查看整票运单轨迹；当前接口未标明每条轨迹对应的子单。': 'Tracking is available for the entire shipment. The current API does not identify which package each event belongs to.'
})

Object.assign(translations, {
  // Common controls and scheduler
  '指定': 'Specify',
  '不指定': 'Not Specified',
  '可多选': 'Multiple selections allowed',
  '周期从': 'Cycle starts at',
  '从': 'From',
  '日': 'Day',
  '周': 'Week',
  '月': 'Month',
  '年': 'Year',
  '小时': 'Hour',
  '分钟': 'Minute',
  '秒': 'Second',
  '每月': 'Every month',
  '每年': 'Every year',
  '第': 'The',
  '时间表达式': 'Time Expression',
  'Cron 表达式': 'Cron Expression',
  'Cron表达式生成器': 'Cron Expression Builder',
  '生成表达式': 'Generate Expression',
  'cron执行表达式': 'Cron Expression',
  '最近5次运行时间': 'Next Five Run Times',
  '计算结果中...': 'Calculating results...',
  '日，允许的通配符[, - * ? / L W]': 'Day of month; allowed wildcards: [, - * ? / L W]',
  '号开始，每': 'Start on day; repeat every',
  '日执行一次': 'Run once per day',
  '号最近的那个工作日': 'Nearest weekday to the selected date',
  '本月最后一天': 'Last day of the month',
  '小时，允许的通配符[, - * /]': 'Hour; allowed wildcards: [, - * /]',
  '小时开始，每': 'Start at hour; repeat every',
  '小时执行一次': 'Run once per hour',
  '分钟，允许的通配符[, - * /]': 'Minute; allowed wildcards: [, - * /]',
  '分钟开始，每': 'Start at minute; repeat every',
  '分钟执行一次': 'Run once per minute',
  '月，允许的通配符[, - * /]': 'Month; allowed wildcards: [, - * /]',
  '月开始，每': 'Start in month; repeat every',
  '月月执行一次': 'Run once per month',
  '秒，允许的通配符[, - * /]': 'Second; allowed wildcards: [, - * /]',
  '秒开始，每': 'Start at second; repeat every',
  '秒执行一次': 'Run once per second',
  '周，允许的通配符[, - * ? / L #]': 'Day of week; allowed wildcards: [, - * ? / L #]',
  '周期从星期': 'Weekly cycle starts on',
  '周的星期': 'Weekday of the month',
  '本月最后一个星期': 'Last weekday of the month',
  '不填，允许的通配符[, - * /]': 'Leave blank; allowed wildcards: [, - * /]',
  '年开始，每': 'Start in year; repeat every',
  '年执行一次': 'Run once per year',
  '文件空间': 'File Space',
  '请输入图标名称': 'Enter icon name',
  '筛选列': 'Choose Columns',
  '隐藏搜索': 'Hide Search',
  '显示搜索': 'Show Search',
  '正在登录中...': 'Signing in...',
  '清空': 'Clear',
  '修改': 'Modify',
  '详细': 'Details',
  '取 消': 'Cancel',
  '生成': 'Generate',
  // Logs
  '登录时间': 'Login Time',
  '操作状态': 'Operation Status',
  '操作信息': 'Operation Details',
  '日志编号': 'Log ID',
  '请求用户': 'Requesting User',
  '请求方法': 'Request Method',
  '请求内容': 'Request Content',
  '接口信息': 'API Information',
  '请求参数': 'Request Parameters',
  '返回参数': 'Response Data',
  '请求状态': 'Request Status',
  '请求时间': 'Request Time',
  '操作IP': 'Operation IP',
  '请输入登录用户名称': 'Enter login username',
  '请选择登录状态': 'Select login status',
  '请选择操作类型': 'Select operation type',
  '请选择请求方式': 'Select request method',
  '请选择操作用户': 'Select a user',
  '请选择操作状态': 'Select operation status',
  // Jobs
  '任务编号': 'Job ID',
  '任务状态': 'Job Status',
  '任务详细': 'Job Details',
  '任务信息': 'Job Information',
  '任务备注': 'Job Remarks',
  '执行一次': 'Run Once',
  '立即执行': 'Run Now',
  '放弃执行': 'Skip Execution',
  '允许': 'Allowed',
  '禁止': 'Disabled',
  '暂停': 'Pause',
  '未更新': 'Not Updated',
  '调用字符': 'Invocation String',
  '执行策略': 'Execution Policy',
  '是否并发': 'Allow Concurrent Runs',
  'cron表达式': 'Cron Expression',
  '调度日志': 'Scheduler Logs',
  '创建者': 'Created By',
  '更新者': 'Updated By',
  '请输入任务名称': 'Enter job name',
  '请输入任务分组': 'Enter job group',
  '请输入任务编号': 'Enter job ID',
  '请选择任务状态': 'Select job status',
  '请输入调用目标': 'Enter invocation target',
  '请输入调用字符': 'Enter invocation string',
  '请输入任务信息': 'Enter job information',
  '请输入执行状态': 'Select execution status',
  '请输入cron执行表达式': 'Enter a cron expression',
  '正在加载定时任务调度日志信息': 'Loading scheduler logs',
  '正在加载定时任务信息': 'Loading scheduled jobs',
  "Bean调用示例：systemTask.execute('transportation')": "Bean example: systemTask.execute('transportation')",
  "Class类调用示例：com.changge.system.task.SystemTask.execute('transportation')": "Class example: com.changge.system.task.SystemTask.execute('transportation')",
  '参数说明：支持字符串，布尔类型，长整型，浮点型，整型': 'Parameters may be strings, booleans, long integers, floating point numbers, or integers'
})

Object.assign(translations, {
  // Cache and server monitoring
  '序号': 'No.',
  '浏览器': 'Browser',
  '可用大小': 'Available Space',
  '总内存': 'Total Memory',
  '缓存分类': 'Cache Categories',
  '缓存列表': 'Cache Entries',
  '缓存内容': 'Cache Value',
  '缓存名称': 'Cache Name',
  '缓存键名': 'Cache Key',
  '缓存名称:': 'Cache Name:',
  '缓存键名:': 'Cache Key:',
  '缓存内容:': 'Cache Value:',
  '正在加载缓存分类': 'Loading cache categories',
  '正在加载缓存列表': 'Loading cache entries',
  '正在加载缓存信息': 'Loading cache details',
  '正在加载缓存监控数据': 'Loading cache metrics',
  'Redis版本': 'Redis Version',
  '运行模式': 'Operating Mode',
  '端口': 'Port',
  '客户端数': 'Connected Clients',
  '运行时间(天)': 'Uptime (Days)',
  '使用内存': 'Memory Used',
  '使用CPU': 'CPU Used',
  '内存配置': 'Memory Configuration',
  'AOF是否开启': 'AOF Enabled',
  'RDB是否成功': 'RDB Save Successful',
  'Key数量': 'Key Count',
  '网络入口/出口': 'Network In / Out',
  '命令统计': 'Command Statistics',
  '内存信息': 'Memory Information',
  '磁盘信息': 'Disk Information',
  '磁盘名称': 'Disk Name',
  '磁盘路径': 'Disk Path',
  '磁盘大小': 'Disk Size',
  '已用大小': 'Used Space',
  'CPU核心数': 'CPU Cores',
  '系统CPU使用率': 'System CPU Usage',
  '用户CPU使用率': 'User CPU Usage',
  '当前CPU空闲率': 'Idle CPU',
  '内存监控': 'Memory Monitoring',
  '服务器内存': 'Server Memory',
  '服务器内存使用率': 'Server Memory Usage',
  'JVM内存': 'JVM Memory',
  'JVM内存使用率': 'JVM Memory Usage',
  '磁盘状态': 'Disk Status',
  '磁盘类型：': 'Disk Type:',
  '磁盘路径：': 'Disk Path:',
  '总大小': 'Total Size',
  '服务器信息': 'Server Information',
  '服务器名称': 'Server Name',
  '服务器IP': 'Server IP',
  '系统架构': 'System Architecture',
  'Java虚拟机信息': 'Java Virtual Machine',
  'Java名称': 'Java Name',
  'Java版本': 'Java Version',
  '启动时间': 'Started At',
  '运行时长': 'Uptime',
  '安装路径': 'Installation Path',
  '项目路径': 'Project Path',
  '运行参数': 'Runtime Arguments'
})

Object.assign(translations, {
  // Users, roles, dictionaries, menus and API permissions
  '模块名称': 'Module Name',
  '模块描述': 'Module Description',
  '数据标签': 'Data Label',
  '数据键值': 'Data Value',
  '字典排序': 'Dictionary Sort Order',
  '样式属性': 'Style Class',
  '回显样式': 'Display Style',
  '页面权限': 'Page Permissions',
  '资源权限': 'API Permissions',
  '资源模块': 'API Module',
  '正在加载字典数据信息': 'Loading dictionary entries',
  '正在加载字典类型信息': 'Loading dictionary types',
  '刷新缓存': 'Refresh Cache',
  '请输入数据标签': 'Enter data label',
  '请输入数据键值': 'Enter data value',
  '请输入样式属性': 'Enter style class',
  '请输入回显样式': 'Enter display style',
  '请输入字典名称': 'Enter dictionary name',
  '请输入字典类型': 'Enter dictionary type',
  '请选择字典类型': 'Select dictionary type',
  '请选择字典数据状态': 'Select dictionary entry status',
  '请选择字典状态': 'Select dictionary status',
  '请输入角色名称': 'Enter role name',
  '请输入角色标识': 'Enter role key',
  '请输入角色描述': 'Enter role description',
  '输入关键字进行过滤': 'Enter a keyword to filter',
  '正在加载角色信息': 'Loading role details',
  '正在加载角色菜单关联信息': 'Loading role menu assignments',
  '正在加载模块角色关联信息': 'Loading role module assignments',
  '正在加载资源模块关联信息': 'Loading API module assignments',
  '展开/折叠': 'Expand / Collapse',
  '目录': 'Directory',
  '菜单': 'Menu',
  '激活菜单': 'Active Menu',
  '路由地址': 'Route Path',
  '是否外链': 'External Link',
  '是否缓存': 'Cache Page',
  '不缓存': 'Do Not Cache',
  '缓存': 'Cache',
  '显示状态': 'Visibility',
  '显示': 'Show',
  '隐藏': 'Hide',
  '图标': 'Icon',
  '排序': 'Sort Order',
  '上级菜单': 'Parent Menu',
  '选择上级菜单': 'Select Parent Menu',
  '菜单类型': 'Menu Type',
  '菜单图标': 'Menu Icon',
  '点击选择图标': 'Choose Icon',
  '显示排序': 'Display Order',
  '请输入菜单名称名称': 'Enter menu name',
  '请输入菜单名称': 'Enter menu name',
  '请选择菜单状态': 'Select menu status',
  '请输入激活菜单路由': 'Enter the active menu route',
  '请输入路由地址': 'Enter route path',
  '请输入组件路径': 'Enter component path',
  '正在加载菜单信息': 'Loading menu details',
  '接口管理': 'API Management',
  '导出接口': 'Export APIs',
  '正在加载接口模块数据': 'Loading API modules',
  '正在加载资源模块信息': 'Loading API module details',
  '正在加载资源信息': 'Loading API details',
  '请输入模块名称': 'Enter module name',
  '请输入模块描述': 'Enter module description',
  '请输入资源名称': 'Enter API name',
  '请输入资源描述': 'Enter API description',
  '请选择请求类型': 'Select request method',
  '请选择接口请求类型': 'Select API request method',
  '请输入请求路径': 'Enter request path',
  '请输入接口请求路径': 'Enter API request path',
  '当前组件路由对应的菜单，如访问路由：`/system-content/dict-data/test_dict_type` 时，默认激活的菜单路由为`/system/dict-type`': 'The menu route to highlight for this component. For example, when visiting `/system-content/dict-data/test_dict_type`, highlight `/system/dict-type`.',
  '访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头': 'Route path, for example `user`. For an embedded external page, begin with `http(s)://`.',
  '访问的组件路径，如：`system/user/index`，默认在`views`目录下': 'Component path, for example `system/user/index`, relative to `views`.',
  '选择是外链则路由地址需要以`http(s)://`开头': 'For an external link, the route must begin with `http(s)://`.',
  '选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致': 'Cached pages use `keep-alive`; the component name must match its route.',
  '选择隐藏则路由将不会出现在侧边栏，但仍然可以访问': 'Hidden routes remain accessible but do not appear in the sidebar.',
  '选择停用则路由将不会出现在侧边栏，也不能被访问': 'Disabled routes are hidden from the sidebar and cannot be accessed.'
})

Object.assign(translations, {
  // Error pages, file storage and site configuration
  '你没有权限去该页面': 'You do not have permission to view this page',
  '如有不满请联系你领导': 'Contact your administrator if you need access',
  '或者你可以去:': 'You can also go to:',
  '回首页': 'Go Home',
  '返回首页': 'Back to Home',
  '随便看看': 'Browse Other Pages',
  '随便看': 'Browse',
  '点我看图': 'View Image',
  '404错误': '404 Error',
  '找不到网页！': 'Page Not Found',
  '对不起，您正在寻找的页面不存在。尝试检查URL的错误，然后按浏览器上的刷新按钮或尝试在我们的应用程序中找到其他内容。': 'The page you requested does not exist. Check the URL, refresh the page, or explore another section of the application.',
  '在这里编辑系统基本配置项，定制您的个性化设置': 'Edit basic system settings here to customize your application.',
  '本地策略': 'Local Storage',
  'OSS策略': 'Object Storage',
  'MinIO 对象存储': 'MinIO Object Storage',
  '取消编辑': 'Cancel Editing',
  '正在加载系统基本配置数据': 'Loading system settings',
  '用户默认头像：': 'Default User Avatar:',
  '上传策略：': 'Upload Policy:',
  '点击进入系统配置': 'Open System Settings',
  '只能上传 .jpeg .jpg .png .gif 格式的文件，且不超过2MB': 'Upload a .jpeg, .jpg, .png, or .gif file no larger than 2 MB',
  '正在删除文件...': 'Deleting file...',
  '文件信息': 'File Information',
  '文件名称': 'File Name',
  '上传用户': 'Uploaded By',
  '文件大小': 'File Size',
  '上传时间': 'Uploaded At',
  '文件标识': 'File ID',
  '文件类型': 'File Type',
  '上传策略': 'Upload Policy',
  '文件存储路径': 'Storage Path',
  '文件访问路径': 'Access URL',
  '点击下载': 'Download',
  '分类': 'Category',
  '上传文件': 'Upload Files',
  '清空选中文件': 'Clear Selection',
  '删除选中文件': 'Delete Selected Files',
  '文件分类：': 'File Category:',
  '将文件拖到此处，或': 'Drop files here, or',
  '点击上传': 'Click to Upload',
  '确定上传': 'Confirm Upload',
  '拼命加载文件资源中': 'Loading files',
  // Code generator
  '表格名称': 'Table Name',
  '表格描述': 'Table Description',
  '包名称': 'Package Name',
  '二级缓存': 'Second-Level Cache',
  '链式编程': 'Fluent API',
  '开启': 'Enabled',
  '不开启': 'Disabled',
  '请输入表格名称': 'Enter table name',
  '请输入包名称': 'Enter package name'
})

Object.assign(translations, {
  '信息': 'Information',
  '图标: check': 'Icon: check',
  '若依': 'RuoYi',
  '文件上传': 'File Upload',
  '正在加载文件上传资源...': 'Loading upload resources...',
  '请选择文件分类': 'Select file category',
  '正在加载文件分类资源...': 'Loading file categories...',
  '分类名称': 'Category Name',
  '请填写分类名称': 'Enter category name',
  '分类标识': 'Category Key',
  '请填写分类标识': 'Enter category key',
  '分类排序': 'Category Sort Order',
  '分类描述': 'Category Description',
  '请填写分类描述': 'Enter category description',
  '批量删除': 'Delete Selected',
  '请选择是否二级缓存': 'Select whether to use second-level cache',
  '请选择是否开启链式编程': 'Select whether to enable the fluent API',
  '正在加载代码生成数据': 'Loading generated code records',
  '生成时间': 'Generated At',
  '生成历史': 'Generation History',
  '复制': 'Copy',
  '请输入表格描述': 'Enter table description',
  '代码生成配置': 'Code Generation Settings',
  '正在加载代码生成配置信息': 'Loading code generation settings',
  '选择是否开启链式编程': 'Select whether to enable the fluent API',
  '选择是否开启二级缓存': 'Select whether to use second-level cache'
})

Object.assign(translations, {
  // Shipping page confirmations and feedback
  '重量': 'Weight',
  '尺寸': 'Dimensions',
  '必填': 'Required',
  '0.00%（默认）': '0.00% (Default)',
  '导入账单': 'Import Statement',
  '导入记录': 'Import History',
  '查看面单': 'View Shipping Label',
  '轨迹': 'Tracking',
  '刷新': 'Refresh',
  '押金记录': 'Deposit History',
  '未分类': 'Uncategorized',
  '已完成': 'Completed',
  '物流断更': 'Tracking Not Updated',
  '送错地址': 'Delivered to Wrong Address',
  '已派送未收到': 'Marked Delivered but Not Received',
  '其他': 'Other',
  '产品图片': 'Product Photos',
  '货物价值图片': 'Proof of Goods Value',
  '破损图片': 'Damage Photos',
  '未上架截图': 'Listing Screenshot',
  '沟通截图': 'Communication Screenshot',
  '其他产品': 'Other Products',
  '请上传产品证明照片': 'Upload product evidence photos',
  '请上传销售截图或货值凭证，至少1张': 'Upload at least one sales screenshot or proof of goods value',
  '破损索赔请上传包装各面、标签和货物破损照片，共7张': 'For damage claims, upload seven photos covering the packaging, label, and damaged goods',
  '可上传平台未上架截图': 'You may upload a screenshot showing the item was not listed',
  '可上传与收件人的聊天记录': 'You may upload a conversation with the recipient',
  '示例：姓名: John Smith  公司: ABC Inc.  电话:+1 123 456 7890  地址: 123 Madison Ave  城市: New York  州省: NY  邮编: 10010  邮箱: john@example.com': 'Example: Name: John Smith  Company: ABC Inc.  Phone:+1 123 456 7890  Address: 123 Madison Ave  City: New York  State: NY  ZIP: 10010  Email: john@example.com',
  '请先选择下单客户': 'Select the ordering customer first',
  '请先选择至少一个产品': 'Select at least one product',
  '未收到该产品的试算结果': 'No quote was returned for this product',
  '提交预报失败': 'Order submission failed',
  '账户可用余额不足，请联系管理员充值美元余额后再提交': 'Insufficient available balance. Contact an administrator to add funds before submitting.',
  '请先选择下单用户': 'Select the ordering user first',
  '关联订单读取失败': 'Could not load the related order',
  '当前订单信息不完整，无法扣取押金': 'The order details are incomplete; the deposit cannot be deducted',
  '记录过多，未能完整导出，请缩小查询时间范围': 'Too many records to export. Narrow the date range and try again.',
  '项目': 'Item',
  '金额 (USD)': 'Amount (USD)',
  '原始账单文件不可用': 'The original statement file is unavailable',
  '原始账单下载失败': 'Could not download the original statement',
  '将按客户单号、主单号匹配订单，并使用 Excel 第12列合计作为平台最终出账金额。确认导入并执行账单补扣？': 'Orders will be matched by customer and master waybill numbers. The total in Excel column 12 will be used as the final provider charge. Import and apply any additional charge?',
  '确认导入': 'Confirm Import',
  '预扣费金额(USD)': 'Pending Charge (USD)',
  '押金扣款(USD)': 'Deposit Deduction (USD)',
  '将先删除原平台订单，成功后移入回收站。已扣费用和流水不会自动退回，确认删除？': 'The order will first be deleted on the provider platform, then moved to the recycle bin. Charges and transaction records will not be refunded automatically. Continue?',
  '删除后订单将进入回收站，已扣费用不会自动退回；如需恢复请联系管理员。确认删除？': 'The order will move to the recycle bin. Charges will not be refunded automatically. Contact an administrator to restore it. Continue?',
  '订单已删除，但列表刷新失败，请手动查询回收站': 'The order was deleted, but the list did not refresh. Check the recycle bin.',
  '订单删除失败': 'Could not delete the order',
  '请联系管理员进行恢复。': 'Contact an administrator to restore this order.',
  '请先在原平台恢复该订单。点击“核实恢复”后，系统将查询原平台状态；未恢复的订单仍留在回收站。': 'Restore the order on the provider platform first. Verify Restore will then check its status. Unrestored orders remain in the recycle bin.',
  '该订单仅在本系统归档，确认将其恢复到订单列表？': 'This order was archived only in this system. Restore it to the order list?',
  '核实恢复': 'Verify Restore',
  '订单已恢复，但列表刷新失败，请手动查询订单列表': 'The order was restored, but the list did not refresh. Search the order list.',
  '订单恢复失败': 'Could not restore the order',
  '已同步当前页前 20 条订单，其余可逐条刷新': 'The first 20 orders on this page were synced. Refresh the remaining orders individually.',
  '账单押金返还': 'Statement Deposit Refund',
  '订单地址无效': 'Invalid Order Address',
  '面单': 'Shipping Label',
  '面单暂时无法预览，请稍后重试。': 'The shipping label cannot be previewed right now. Try again later.',
  '面单暂时无法下载，请稍后重试': 'The shipping label cannot be downloaded right now. Try again later.',
  '加价调整记录加载失败': 'Could not load markup history',
  '单个凭证不能超过5MB': 'Each evidence file must be 5 MB or smaller',
  '充值金额必须大于 0': 'Recharge amount must be greater than zero',
  '充值失败，请查询流水后重试': 'Recharge failed. Check the transaction history before retrying.',
  '扣取金额必须大于 0': 'Deduction amount must be greater than zero',
  '关联订单已变更，请重新选择后操作': 'The related order has changed. Select it again.',
  '押金已扣取，客户将收到通知': 'The deposit was deducted and the customer will be notified',
  '当前浏览器不支持安全的资金操作，请使用新版浏览器': 'This browser does not support secure financial transactions. Use a current browser.',
  '确认删除该联系人？': 'Delete this contact?',
  '请上传不超过5MB的JPG或PNG图片': 'Upload a JPG or PNG image no larger than 5 MB',
  '照片上传失败': 'Photo upload failed',
  '请选择索赔类型': 'Select a claim type',
  '请填写完整的货物信息': 'Complete the goods information',
  '请上传产品图片和货物价值图片': 'Upload product photos and proof of goods value',
  '破损索赔需上传7张破损证明照片': 'Damage claims require seven evidence photos',
  '请填写处理说明': 'Enter a resolution description'
})

Object.assign(translations, {
  // Dispute page
  '查看/处理': 'View / Process',
  '暂无运单号': 'No waybill number',
  '提交争议': 'Submit Dispute',
  '异型': 'Irregular Size',
  '已关闭': 'Closed',
  '争议列表加载失败': 'Could not load disputes',
  '争议详情加载失败': 'Could not load dispute details',
  '订单加载失败': 'Could not load orders',
  '该订单暂无子单号，可按主运单申请争议': 'No package numbers are available for this order. You can dispute the master waybill.',
  '子单号获取失败': 'Could not load package numbers',
  '请上传不超过2MB的JPG或PNG图片': 'Upload a JPG or PNG image no larger than 2 MB',
  '最多上传5张照片': 'Upload up to 5 photos',
  '照片读取失败': 'Could not read the photo',
  '请选择争议类型和关联订单': 'Select a dispute type and related order',
  '请选择处理状态并填写处理说明': 'Select a resolution status and enter a description',
  '争议已保存': 'Dispute saved',
  '争议保存失败': 'Could not save the dispute'
})

Object.assign(translations, {
  // Fixed API validation and billing messages
  '加价比例应在0至1000%之间': 'Markup must be between 0% and 1000%',
  '请选择1至500个产品进行批量配置': 'Select 1 to 500 products for batch configuration',
  '产品编码不能为空或重复': 'Product codes must be present and unique',
  '请输入加价比例': 'Enter a markup rate',
  '加价比例应在0至1000%之间，最多保留两位小数': 'Markup must be between 0% and 1000% with at most two decimal places',
  '产品状态选项无效': 'Invalid product status',
  '调整原因不能超过500字': 'The reason must be 500 characters or fewer',
  '部分产品已不存在，请刷新列表后重试': 'Some products no longer exist. Refresh the list and try again.',
  '通过相关接口同步': 'Synced from the connected provider',
  '仅支持美元余额': 'Only USD balances are supported',
  '预报状态在限定时间内未确认，请人工核对后再处理': 'Order submission was not confirmed within the allowed time. Review it manually before taking further action.',
  '实际预扣费或币种与试算结果不一致，请管理员核对': 'The reserved amount or currency differs from the quote. Ask an administrator to review it.',
  '原平台未返回响应': 'The provider did not respond',
  '无法核实原平台恢复状态，请稍后重试': 'Could not verify the provider restoration status. Try again later.',
  '请选择账单 Excel 文件': 'Select a statement Excel file',
  '账单 Excel 无法读取，请确认文件未损坏': 'Could not read the statement Excel file. Check that it is not damaged.',
  '账单 Excel 没有数据': 'The statement Excel file contains no data',
  '客户单号': 'Customer Order Number',
  '主单号': 'Master Waybill Number',
  '合计': 'Total',
  '客户单号和主单号必须同时存在': 'Both customer order number and master waybill number are required',
  '本批次出现重复的客户单号和主单号': 'This batch contains a duplicate customer order and master waybill pair',
  '合计金额不能为负数': 'The total amount cannot be negative',
  '未找到同时匹配的订单': 'No order matched both numbers',
  '匹配到多条订单，未执行扣费': 'Multiple orders matched; no charge was made',
  '处理失败，请检查订单和账单数据': 'Processing failed. Check the order and statement data.',
  '只有预报成功订单才能导入平台出账': 'Only successfully submitted orders can receive provider charges',
  '订单币种不是 USD，不能按美元账单扣费': 'The order currency is not USD; a USD statement cannot be charged',
  '订单原始报价或客户扣费金额异常，请人工核对': 'The original quote or customer charge is invalid. Review it manually.',
  '订单原始扣费流水与订单金额不一致，请人工核对': 'The original debit transaction does not match the order amount. Review it manually.',
  '该文件已导入过，订单已有更新的账单金额；旧文件不能覆盖新账单': 'This file was already imported and the order has a newer billed amount. An old file cannot overwrite it.',
  '金额未变化，押金仍不足，未重复扣费': 'The amount has not changed and the deposit is still insufficient. No duplicate charge was made.',
  '该出账金额已导入，未重复扣费': 'This billed amount was already imported. No duplicate charge was made.',
  '账单导入记录不存在': 'Statement import record not found',
  '原始账单文件校验失败，请联系管理员核对归档数据': 'The original statement failed verification. Ask an administrator to review the archived file.',
  '订单账单补扣与已收金额不一致，请人工核对': 'The additional billing charge does not match the amount collected. Review it manually.',
  '客户押金余额异常，请人工核对': 'The customer deposit balance is invalid. Review it manually.',
  '平台账单补扣': 'Additional Provider Billing Charge',
  '账单补扣押金通知': 'Deposit Deduction for Additional Billing',
  '平台账单金额更正，返还押金': 'Provider Statement Corrected; Deposit Refunded',
  '账单更正押金返还通知': 'Deposit Refund for Statement Correction',
  '账单补扣押金不足': 'Insufficient Deposit for Additional Billing',
  '账单补扣余额不足': 'Insufficient Balance for Additional Billing',
  '账单已导入并结清': 'Statement imported and settled',
  '账单已导入，但押金不足': 'Statement imported, but the deposit is insufficient',
  '合计金额不能为空': 'The total amount is required',
  '分页参数必须大于零': 'Page parameters must be greater than zero',
  '分页参数格式不正确': 'Invalid page parameters',
  '充值金额必须大于0': 'Recharge amount must be greater than zero',
  '充值金额最多保留两位小数': 'Recharge amount may have at most two decimal places',
  '充值备注不能超过500字': 'Recharge remarks must be 500 characters or fewer',
  '入账金额超过账户支持的最大金额': 'The recharge exceeds the maximum supported account amount',
  '押金金额必须大于0': 'Deposit amount must be greater than zero',
  '押金金额最多保留两位小数': 'Deposit amount may have at most two decimal places',
  '押金方向必须为 CREDIT、RETURN 或 DEBIT': 'Deposit direction must be CREDIT, RETURN, or DEBIT',
  '关联订单号不存在或不属于该客户': 'The related order does not exist or does not belong to this customer',
  '扣取押金必须填写关联订单号': 'A related order number is required for a deposit deduction',
  '只能对预报成功订单扣取押金': 'A deposit can be deducted only for a successfully submitted order',
  '押金币种必须与订单币种一致': 'The deposit currency must match the order currency',
  '实际运费必须高于订单客户实付金额': 'Actual shipping cost must exceed the amount paid by the customer',
  '扣取金额超过尚未扣取的超额运费': 'The deduction exceeds the remaining excess shipping cost',
  '请上传有效的证据文件': 'Upload a valid evidence file',
  '押金扣款通知': 'Deposit Deduction Notice',
  '请选择不超过5MB的图片或PDF文件': 'Select an image or PDF no larger than 5 MB',
  '仅支持PNG、JPG或PDF证据文件': 'Evidence files must be PNG, JPG, or PDF',
  '读取证据文件失败': 'Could not read the evidence file',
  '账单记录暂时无法更新，请稍后重试；当前账单仍可查看': 'The statement could not be updated right now. Try again later; the current statement remains available.',
  '平台账单查询时间范围不能超过一年': 'The statement date range cannot exceed one year'
})

Object.assign(translations, {
  '联系人类型不正确': 'Invalid contact type',
  '联系人姓名、电话、国家代码和地址不能为空': 'Contact name, phone, country code, and address are required',
  '客户不能修改已提交的索赔': 'Customers cannot edit a submitted claim',
  '订单不能为空': 'An order is required',
  '索赔原因不能为空': 'A claim reason is required',
  '索赔类型不正确': 'Invalid claim type',
  '客户不能为空': 'A customer is required',
  '仅预报成功的订单可提交索赔': 'Claims can be submitted only for successfully submitted orders',
  '索赔状态不正确': 'Invalid claim status',
  '请填写索赔处理说明': 'Enter a claim resolution description',
  '请填写货物信息': 'Enter goods information',
  '单件产品数须为1至9999的整数': 'Units per package must be an integer from 1 to 9999',
  '产品单价须大于0，最多两位小数': 'Unit price must be greater than zero with at most two decimal places',
  '产品尺寸须大于0且不超过9999厘米': 'Product dimensions must be greater than zero and no more than 9999 cm',
  '产品名称和颜色必须填写，最多200字': 'Product name and color are required and must be 200 characters or fewer',
  '货物信息最多200字': 'Goods information must be 200 characters or fewer',
  '请上传产品照片和货值凭证': 'Upload product photos and proof of goods value',
  '破损索赔需要上传7张破损证明照片': 'Damage claims require seven evidence photos',
  '同一张照片不能重复作为多项凭证': 'The same photo cannot be used for multiple evidence categories',
  '货物凭证仅支持图片': 'Goods evidence must be an image',
  '照片数量超过限制': 'Too many photos',
  '附件编号无效': 'Invalid attachment ID',
  '索赔附件无效': 'Invalid claim attachment',
  '索赔货物信息无法读取': 'Could not read claim goods information',
  '已提交的争议只能由管理员处理': 'Only an administrator can process a submitted dispute',
  '请选择处理状态并填写不超过1000字的处理说明': 'Select a resolution status and enter a description of no more than 1000 characters',
  '争议处理进度通知': 'Dispute Status Update',
  '请选择客户和关联订单': 'Select a customer and related order',
  '仅预报成功的订单可申请争议': 'Disputes can be submitted only for successfully submitted orders',
  '争议类型不正确': 'Invalid dispute type',
  '子单数量超过限制': 'Too many package numbers',
  '子单号格式不正确': 'Invalid package number format',
  '子单号不能重复': 'Package numbers must be unique',
  '争议照片须为图片且单张不超过2MB': 'Dispute photos must be images no larger than 2 MB each',
  '争议说明不能超过1000字': 'Dispute description must be 1000 characters or fewer',
  '争议子单信息无法读取': 'Could not read dispute package details',
  '争议记录不存在': 'Dispute record not found',
  '单件信息暂时无法获取，请稍后重试': 'Package details are unavailable right now. Try again later.',
  '运单轨迹暂时无法获取，请稍后重试': 'Shipment tracking is unavailable right now. Try again later.',
  '平台返回的轨迹与当前订单不一致，请稍后重试': 'The provider tracking data does not match this order. Try again later.',
  '参考编号只能包含字母、数字、下划线和减号，最长35位': 'Reference number may contain letters, digits, underscores, and hyphens, up to 35 characters',
  '收件人、收件公司、电话、地址、国家代码、州/城市、邮编和申报币种不能为空': 'Recipient name, company, phone, address, country code, state/city, ZIP code, and declared currency are required',
  '重量必须大于0': 'Weight must be greater than zero',
  '总重量最多保留三位小数': 'Total weight may have at most three decimal places',
  '至少填写一组货物尺寸': 'Enter at least one set of package dimensions',
  '货物尺寸格式不正确': 'Invalid package dimensions',
  '每组货物件数必须为1至999的整数': 'Package count per dimension group must be an integer from 1 to 999',
  '单件重量和长宽高必须大于0': 'Weight and dimensions per package must be greater than zero',
  '单件重量和长宽高不能超过999': 'Weight and dimensions per package cannot exceed 999',
  '接口要求单件重量最多三位小数、长宽高最多一位小数（KG/CM）': 'The API requires up to three decimals for weight and one decimal for dimensions per package (kg/cm)',
  '日期格式应为 yyyy-MM-dd 或 yyyy-MM-dd HH:mm:ss': 'Date format must be yyyy-MM-dd or yyyy-MM-dd HH:mm:ss',
  '账户仅支持美元余额；非美元报价暂不能提交预报': 'This account supports USD only. Orders with non-USD quotes cannot be submitted.',
  '币种必须是三位字母代码': 'Currency must be a three-letter code',
  '下单用户不存在或已停用': 'The ordering user does not exist or is disabled',
  '该资金操作已处理，请刷新流水确认，勿重复提交': 'This financial transaction was already processed. Refresh the transaction history before retrying.',
  '资金操作请求标识无效，请刷新页面重试': 'Invalid financial request ID. Refresh the page and try again.',
  '通知不存在': 'Notice not found',
  '外部预报失败退回订单费用': 'Order charge refunded after provider submission failed',
  '相关接口未返回可用的报价，请稍后重试': 'No quote was returned by the connected provider. Try again later.',
  '未知错误': 'Unknown error'
})

Object.assign(translations, {
  '处理索赔': 'Process Claim',
  '件数：': 'Packages: ',
  '确认': 'Confirm',
  '充值金额(USD)': 'Recharge Amount (USD)',
  '充值后余额(USD)': 'Balance After Recharge (USD)',
  '上期余额(USD)': 'Opening Balance (USD)',
  '发生金额(USD)': 'Transaction Amount (USD)',
  '本期余额(USD)': 'Closing Balance (USD)'
})

Object.assign(translations, {
  '起运港': 'Origin Port',
  '目的港': 'Destination Port',
  '预计到达': 'Estimated Arrival'
})

Object.assign(translations, {
  '号码查询': 'Number Search',
  '请输入号码': 'Enter a number',
  '全部状态': 'All Statuses',
  '全部类型': 'All Types',
  '争议已关闭': 'Dispute Closed',
  '已关闭': 'Closed',
  '最多上传5张，单张不超过2MB': 'Up to 5 photos, 2 MB each',
  '提示：重量、尺寸、异型争议请至少上传3张清晰的证明照片；这些照片将用于后续审核。': 'For weight, dimensions, or irregular package disputes, upload at least 3 clear evidence photos for review.',
  '暂无可导出的争议记录': 'No dispute records to export',
  '导出记录超过20000条，请缩小查询范围': 'More than 20,000 dispute records match. Narrow the filters before exporting.',
  '争议记录导出失败': 'Could not export dispute records'
})

// Customer-facing deposit terminology. Keep the internal DEPOSIT API and
// ledger names unchanged while presenting 押金 consistently in the UI.
Object.assign(translations, {
  '押金管理': 'Deposit Management',
  '押金不足': 'Insufficient Deposit',
  '押金扣款': 'Deposit Deduction',
  '查看押金扣款记录': 'View deposit deduction records',
  '押金扣取 (USD)': 'Deposit Deduction (USD)',
  '押金扣取': 'Deposit Deduction',
  '成功订单押金管理': 'Successful Order Deposits',
  '每笔订单可直接扣取押金，也可查看历史扣款和附件': 'Deduct a deposit directly for each order and view deduction history and attachments',
  '已扣押金 (USD)': 'Deposit Deducted (USD)',
  '扣取押金': 'Deduct Deposit',
  '押金 (USD)': 'Deposit (USD)',
  '押金记录': 'Deposit History',
  '押金余额': 'Deposit Balance',
  '当前押金': 'Current Deposit',
  '扣款后押金 (USD)': 'Deposit After Deduction (USD)',
  '押金扣款记录': 'Deposit Deduction History',
  '暂无押金扣款记录': 'No deposit deduction records',
  '该订单暂无押金扣款记录': 'This order has no deposit deduction records',
  '押金扣款记录读取失败': 'Failed to load deposit deduction records',
  '确认本次押金扣款': 'Confirm this deposit deduction',
  '押金已扣取': 'Deposit deducted',
  '押金操作失败，请查询流水后重试': 'Deposit operation failed. Query transactions and retry.',
  '收取押金': 'Deposit Credit',
  '退还押金': 'Deposit Return',
  '账单押金返还': 'Statement Deposit Refund',
  '删除订单押金退回': 'Deleted Order Deposit Refund',
  '押金变动': 'Deposit Change',
  '押金扣款(USD)': 'Deposit Deduction (USD)',
  '已扣押金': 'Deposit Deducted',
  '押金通知': 'Deposit Notification',
  '押金金额必须大于0': 'Deposit amount must be greater than zero',
  '押金金额最多保留两位小数': 'Deposit amount may have at most two decimal places',
  '押金方向必须为 CREDIT、RETURN 或 DEBIT': 'Deposit direction must be CREDIT, RETURN, or DEBIT',
  '扣取押金必须填写关联订单号': 'A related order number is required for a deposit deduction',
  '只能对预报成功订单扣取押金': 'A deposit can be deducted only for a successfully submitted order',
  '押金币种必须与订单币种一致': 'The deposit currency must match the order currency',
  '押金扣款通知': 'Deposit Deduction Notice',
  '账单补扣押金通知': 'Deposit Deduction for Additional Billing',
  '账单更正押金返还通知': 'Deposit Refund for Statement Correction',
  '账单补扣押金不足': 'Insufficient Deposit for Additional Billing',
  '账单已导入，但押金不足': 'Statement imported, but the deposit is insufficient',
  '金额未变化，押金仍不足，未重复扣费': 'The amount has not changed and the deposit is still insufficient. No duplicate charge was made.',
  '客户押金余额异常，请人工核对': 'The customer deposit balance is invalid. Review it manually.',
  '押金已扣取，客户将收到通知': 'The deposit was deducted and the customer will be notified',
  '当前订单信息不完整，无法扣取押金': 'The order details are incomplete; the deposit cannot be deducted',
  '押金充值': 'Deposit Recharge',
  '为当前客户充值押金': 'Recharge the current customer deposit',
  '充值成功后会记录资金流水，客户可在账户中查看押金余额。': 'The recharge will be recorded and the customer can view the deposit balance in the account.',
  '押金充值金额必须大于 0': 'Deposit recharge amount must be greater than 0',
  '押金充值金额最多保留两位小数': 'Deposit recharge amount may have at most two decimal places',
  '押金充值成功': 'Deposit recharge succeeded',
  '押金充值失败，请查询流水后重试': 'Deposit recharge failed. Query transactions and retry.',
  '已撤销': 'Reversed',
  '已删除': 'Deleted',
  '充值撤销': 'Recharge Reversal',
  '删除充值记录': 'Delete Recharge Record',
  '充值已撤销，原记录已标记为删除': 'Recharge reversed; the original record is marked as deleted.',
  '撤销失败，请核对账户余额和流水': 'Reversal failed. Check the account balance and transaction history.',
  '充值记录无效': 'Invalid recharge record.',
  '充值记录不存在': 'Recharge record not found.',
  '只能撤销充值记录': 'Only recharge records can be reversed.',
  '这条充值已撤销，请刷新记录': 'This recharge has already been reversed. Refresh the records.',
  '原充值金额异常，请人工核对': 'The original recharge amount is invalid. Review it manually.',
  '账户余额不足，无法撤销这条充值；请先核对后续消费流水': 'Insufficient account balance to reverse this recharge. Review subsequent transactions.',

  // ===== 系统管理：菜单 =====
  '新增菜单': 'Add Menu',
  '更新菜单': 'Edit Menu',
  '菜单名称不能为空': 'Menu name is required',
  '菜单顺序不能为空': 'Menu order is required',
  '路由地址不能为空': 'Route path is required',
  '是否确认删除选中的菜单数据？': 'Delete the selected menu(s)?',
  '菜单信息更新成功': 'Menu updated successfully',
  '菜单添加成功': 'Menu created successfully',

  // 角色
  '新增角色': 'Add Role',
  '更新角色': 'Edit Role',
  '是否确认删除选中的角色数据？': 'Delete the selected role(s)?',
  '角色信息更新成功': 'Role updated successfully',
  '角色添加成功': 'Role created successfully',
  '权限分配成功': 'Permissions assigned successfully',
  '权限分配成功成功': 'Permissions assigned successfully',

  // 字典
  '新增字典类型': 'Add Dictionary Type',
  '更新字典类型': 'Edit Dictionary Type',
  '是否确认删除选中的字典类型数据？': 'Delete the selected dictionary type(s)?',
  '字典类型信息更新成功': 'Dictionary type updated successfully',
  '字典类型添加成功': 'Dictionary type created successfully',
  '字典缓存刷新成功': 'Dictionary cache refreshed successfully',
  '新增字典数据': 'Add Dictionary Data',
  '更新字典数据': 'Edit Dictionary Data',
  '请输入状态': 'Select a status',
  '主要': 'Primary',
  '警告': 'Warning',
  '危险': 'Danger',
  '是否确认删除选中的字典数据数据？': 'Delete the selected dictionary data?',
  '字典数据信息更新成功': 'Dictionary data updated successfully',
  '字典数据添加成功': 'Dictionary data created successfully',

  // 安全与资源
  '新增资源模块': 'Add Resource Module',
  '更新资源模块': 'Edit Resource Module',
  '是否确认删除选中的资源模块数据？': 'Delete the selected resource module(s)?',
  '资源模块信息更新成功': 'Resource module updated successfully',
  '资源模块添加成功': 'Resource module created successfully',
  '新增接口信息': 'Add API',
  '编辑请求资源': 'Edit Request Resource',
  '资源信息更新成功': 'Resource updated successfully',
  '是否确认删除选中的接口信息？': 'Delete the selected API?',
  '是否确认删除选中的资源模块关联数据？': 'Delete the selected resource-module association(s)?',

  // 定时任务
  '新增定时任务': 'Add Scheduled Job',
  '更新定时任务': 'Edit Scheduled Job',
  'cron表达式不能为空': 'Cron expression is required',
  '是否确认删除选中的定时任务数据？': 'Delete the selected scheduled job(s)?',
  '定时任务信息更新成功': 'Scheduled job updated successfully',
  '定时任务添加成功': 'Scheduled job created successfully',
  '定时任务状态更新成功': 'Scheduled job status updated successfully',
  '任务执行成功': 'Job executed successfully',
  '更新定时任务调度日志': 'Edit Job Log',
  '是否确认删除选中的定时任务调度日志数据？': 'Delete the selected job log(s)?',

  // 日志
  '请输入登录状态': 'Select a login status',
  '请输入登录时间': 'Select a login time',
  '此操作将永久删除所有登录日志数据, 是否继续?': 'This will permanently delete all login logs. Continue?',
  '是否确认删除选中的用户登录日志数据？': 'Delete the selected login log(s)?',
  '此操作将永久删除所有操作日志数据项, 是否继续?': 'This will permanently delete all operation logs. Continue?',
  '是否确认删除选中的操作日志数据？': 'Delete the selected operation log(s)?',
  '清空成功': 'Cleared successfully',

  // 缓存与监控
  '缓存名称刷新成功': 'Cache name refreshed successfully',
  '缓存键刷新成功': 'Cache key refreshed successfully',
  '缓存列表清除成功': 'Cache list cleared successfully',
  '缓存删除成功': 'Cache deleted successfully',
  '是否清除缓存列表': 'Clear the cache list',
  '是否删除缓存': 'Delete the cache',
  '下线成功': 'User signed out successfully',

  // 文件管理
  '文件分类名称不能为空': 'Category name is required',
  '文件分类标识不能为空': 'Category key is required',
  '请选择分类排序值': 'Select a sort order',
  '文件分类不能为空': 'File category is required',
  '请选择文件': 'Select a file',
  '此操作将永久删除选中文件, 是否继续?': 'This will permanently delete the selected file(s). Continue?',
  '文件删除成功': 'File deleted successfully',
  '新增分类': 'Add Category',
  '编辑分类': 'Edit Category',
  '文件分类操作成功': 'Category saved successfully',
  '此操作将永久删除选中文件分类, 是否继续?': 'This will permanently delete the selected categories. Continue?',
  '文件分类删除成功': 'Category deleted successfully',
  '此操作将永久删除该文件, 是否继续?': 'This will permanently delete this file. Continue?',
  '删除成功!': 'Deleted successfully!',

  // 代码生成
  '模块名称不能为空': 'Module name is required',
  '包名不能为空': 'Package name is required',
  '表注释': 'Table Comment',
  '代码预览': 'Code Preview',
  '复制成功': 'Copied successfully',
  '是否确认删除选中的代码生成日志数据？': 'Delete the selected code generation log(s)?',

  // 通知公告
  '请输入公告内容': 'Enter announcement content',
  '创建人': 'Created by',
  '新增通知公告': 'Add Announcement',
  '更新通知公告': 'Edit Announcement',
  '是否确认删除选中的通知公告数据？': 'Delete the selected announcement(s)?',
  '通知公告信息更新成功': 'Announcement updated successfully',
  '通知公告添加成功': 'Announcement created successfully',
  '最新公告': 'Latest Announcement',
  '点击查看公告详情': 'View announcement details',

  // 个人中心 / 密码
  '请输入新密码': 'Enter a new password',
  '密码长度为 6-20 位': 'Password must be 6-20 characters',
  '两次输入的新密码不一致': 'The two passwords do not match',
  '更新成功': 'Updated successfully',
  '用户头像更新成功': 'Avatar updated successfully',
  '3秒后将自动退出系统，请重新登录': 'You will be signed out automatically in 3 seconds. Please sign in again.',

  // 客户初始附加费
  '初始附加费': 'Initial Markup',
  '填写后应用于该客户全部产品；客户单品配置优先。不填写则使用产品通用比例': 'Applied to all products of this customer; per-product settings take priority. Leave blank to use the default rate.',
  '设置初始附加费': 'Set Initial Markup',
  '客户：': 'Customer: ',
  '保存后应用于该客户全部产品；已配置的客户单品比例保持优先。填写 0% 表示该客户默认不加价。': 'Applied to all products of this customer; existing per-product rates keep priority. Enter 0% for no default markup.',
  '请及时保存密码，关闭后将无法再次查看。': 'Save this password now; it cannot be viewed again after closing.',
  '我已保存': 'I have saved it',
  '请填写初始附加费': 'Enter the initial markup',
  '初始附加费必须在 0% 至 1000% 之间': 'Initial markup must be between 0% and 1000%',
  '初始附加费已保存': 'Initial markup saved',
  '密码已复制': 'Password copied',
  '复制失败，请手动保存密码': 'Copy failed. Please save the password manually.',

  // 运输 / 订单 / 押金
  '发货地': 'Origin',
  '全部发货地': 'All origins',
  '查询后显示所选发货地产品的预估价格': 'Select an origin to see estimated prices',
  '当前发货地没有可试算的产品，请联系管理员': 'No products available for this origin. Please contact an administrator.',
  '关联资金流水': 'Related Transactions',
  '发生金额': 'Amount',
  '所属账户': 'Account',
  '分区 / 账单分区': 'Zone / Billing Zone',
  '删除退款状态': 'Deletion Refund Status',
  '退款计划时间': 'Refund Scheduled At',
  '退款完成时间': 'Refund Completed At',
  '退款状态': 'Refund Status',
  '费用冻结': 'Fee Frozen',
  '已退款': 'Refunded',
  '无需退款': 'No Refund Needed',
  '次日待退款': 'Refund Next Day',
  '退款待重试': 'Refund Retry Pending',
  '删除订单退款': 'Order Deletion Refund',
  '撤回押金补足': 'Deposit Top-up Reversed',
  '补足押金': 'Deposit Top-up',
  '账单正式扣费': 'Statement Charge',
  '冻结金额': 'Frozen Amount',
  '订单金额': 'Order Amount',
  '押金概览': 'Deposit Overview',
  '目标押金': 'Target Deposit',
  '待补押金': 'Deposit Shortfall',
  '待补明细': 'Shortfall Details',
  '用于说明待补押金对应的出账订单': 'Orders causing the deposit shortfall',
  '出账时间': 'Billed At',
  '期初押金': 'Opening Deposit',
  '期末押金': 'Closing Deposit',
  '账单更正返还押金': 'Deposit Returned by Statement Correction',
  '余额流水': 'Balance Transactions',
  '押金流水': 'Deposit Transactions',
  '押金扣除后，系统会自动使用可用余额补足；余额不足的部分会保留在待补明细中': 'The shortfall is covered automatically by the available balance; any remaining amount stays in the shortfall details.',
  '当前押金已达到首次充值标准，无需补充': 'The deposit already meets the initial threshold; no top-up needed.',
  '所属区域': 'Zone',
  '待确定': 'Pending',
  '产品所属区域待确定': 'Product zone pending confirmation',
  '产品所属区域保存失败': 'Failed to save the product zone',
  '当前费率设置': 'Current Exchange Rate',
  '仅用于试算结果的人民币预估展示，订单实际收费仍为美元。': 'Used only for the CNY estimate in quotes; orders are charged in USD.',
  '保存费率': 'Save Rate',
  '请输入大于0且不超过100的汇率': 'Enter a rate greater than 0 and no more than 100',
  '当前费率已更新': 'Exchange rate updated',
  '费率保存失败': 'Failed to save the exchange rate',
  '当前费率读取失败，请刷新页面重试': 'Failed to load the exchange rate. Refresh the page and try again.',
  '客户产品利润读取失败': 'Failed to load customer product markup',
  '客户列表读取失败，请点击客户下拉重试': 'Failed to load the customer list. Open the customer dropdown to retry.',
  '客户列表读取失败，请重试': 'Failed to load the customer list. Please try again.',
  '面单接口未返回PDF文件': 'The label API did not return a PDF file',
  '将先删除原平台订单，成功后移入回收站；冻结金额将在隔天释放。确认删除？': 'The order is first deleted on the original platform, then moved to the recycle bin; frozen amounts are released the next day. Delete anyway?',
  '预报失败的订单将移入回收站，冻结金额将在隔天释放。确认删除？': 'Orders that failed submission are moved to the recycle bin; frozen amounts are released the next day. Delete anyway?',
  '订单已移入回收站，冻结金额将在隔天释放': 'Order moved to the recycle bin; frozen amounts will be released the next day',
  '该订单的删除退款已完成，不能直接恢复；如需恢复请先核对并处理退款流水。': 'This order cannot be restored directly because its deletion refund is complete. Review and settle the refund transactions first.',

  // 争议 / 索赔
  '选择争议类型和对应订单': 'Select a dispute type and the related order',
  '已关联订单': 'Linked Order',
  '上传照片并补充争议说明': 'Upload photos and describe the dispute',
  '证明材料': 'Evidence',
  '争议照片': 'Dispute Photos',
  '移除': 'Remove',
  '照片格式不正确': 'Unsupported photo format',
  '选择索赔类型和对应订单': 'Select a claim type and the related order',
  '填写单件产品与尺寸资料': 'Enter the product and dimensions',
  '按类型上传清晰的图片材料': 'Upload clear images by type',
  '按订单提交索赔申请，查看证明材料和处理进度。': 'Submit claims against orders and track evidence and progress.',
  '请输入索赔单号': 'Enter the claim number',

  // 系统配置
  '无操作自动登出：': 'Auto sign-out on inactivity: ',
  '用户在页面上连续无操作达到该时长后自动退出登录，默认 30 分钟。': 'Sign the user out after this period of inactivity. Default: 30 minutes.',
  '自动登出时间须为 1 至 120 分钟的整数': 'Auto sign-out time must be a whole number between 1 and 120 minutes',
  '正在保存当前配置...': 'Saving the current settings...',
  '正在保存当前配置并刷新...': 'Saving the current settings and refreshing...',

  // 接口错误日志 / 首页运行总览 / 散落补充
  '接口错误日志': 'API Error Logs',
  '查看上游接口调用失败记录、返回码以及完整请求和响应，便于定位异常。': 'Review upstream API call failures, response codes, and the full request and response to locate issues.',
  '时间范围': 'Time Range',
  '近24小时': 'Last 24 Hours',
  '近3天': 'Last 3 Days',
  '近7天': 'Last 7 Days',
  '接口动作': 'API Action',
  '如 CREATE_ORDER': 'e.g. CREATE_ORDER',
  '返回码': 'Response Code',
  '上游返回码': 'Upstream response code',
  '当前范围共': 'In the current range:',
  '条失败记录': 'failed record(s)',
  '这里只统计上游接口调用日志，不等同于“预报失败订单”数量。': 'Only upstream API call logs are counted here. This is not the same as the number of failed shipments.',
  '客户/触发方': 'Customer / Trigger',
  '失败原因': 'Failure Reason',
  '查看详情': 'View Details',
  '接口错误详情': 'API Error Details',
  '响应内容': 'Response Body',
  '无内容': 'No content',
  '同步产品': 'Sync Products',
  '下单前复核': 'Pre-order Review',
  '订单详情核对': 'Order Detail Check',
  '订单详情更新': 'Order Detail Update',
  '获取面单': 'Get Label',
  '查询运单号': 'Query Tracking Number',
  '删除状态核对': 'Deletion Status Check',
  '恢复状态核对': 'Restoration Status Check',
  '获取包裹信息': 'Get Package Info',
  '获取包裹详情': 'Get Package Details',
  '查看订单详情': 'View Order Details',
  '上游接口': 'Upstream API',
  '最近公告': 'Latest Announcements',
  '系统公告记录': 'System Announcements',
  '运行总览': 'Operations Overview',
  '客户新订单入口': 'Customer Order Intake',
  '客户可以正常试算和创建订单。暂停后仍可登录、查看历史订单和资金账户。': 'Customers can quote and create orders normally. After a suspension they can still sign in and view historical orders and the funds account.',
  '恢复客户下单': 'Resume Customer Orders',
  '紧急暂停下单': 'Emergency Pause',
  '按影响程度排列，点击可前往对应功能': 'Sorted by impact. Click an item to open the corresponding feature.',
  '需要管理员处理的问题': 'Issues Requiring Administrator Action',
  '当前没有待处理异常': 'No pending issues at the moment',
  '订单、资金和接口运行正常': 'Orders, funds and APIs are running normally',
  '常用管理入口': 'Frequently used admin entries',
  '紧急处置': 'Emergency Actions',
  '异常订单': 'Exception Orders',
  '产品启停': 'Product Enable / Disable',
  '资金核对': 'Funds Reconciliation',
  '展示待核对和预报失败的最新订单': 'Shows the latest orders that are pending review or failed submission',
  '最近异常订单': 'Recent Exception Orders',
  '直接展示最近的上游失败原因，便于判断是否需要暂停客户下单': 'Shows recent upstream failure reasons so you can decide whether to pause customer orders',
  '近24小时接口失败明细': 'API Failures in the Last 24 Hours',
  '今日新建订单': 'Orders Created Today',
  '所有客户订单': 'All customer orders',
  '上游已确认': 'Confirmed by upstream',
  '今日预报成功': 'Successful Submissions Today',
  'USD 客户最终应付': 'USD finally payable by the customer',
  '今日成功订单金额': 'Successful Order Amount Today',
  'USD 预报成功订单冻结金额': 'USD frozen for successfully booked orders',
  '需要人工确认': 'Manual confirmation required',
  '上游调用失败': 'Upstream call failed',
  '近24小时接口失败': 'API Failures (24h)',
  '客户争议': 'Customer disputes',
  '低于目标押金': 'Below the target deposit',
  '押金不足客户': 'Customers with Insufficient Deposit',
  '仍有未出账件数': 'Pieces still to be billed',
  '运行总览读取失败': 'Failed to load the operations overview',
  '紧急暂停客户下单': 'Emergency Pause of Customer Orders',
  '请填写暂停原因，客户试算和下单时会看到此说明。': 'Enter the suspension reason. Customers will see this note when quoting and creating orders.',
  '例如：上游订单接口异常，正在紧急排查': 'e.g. The upstream order API is abnormal and is being investigated urgently',
  '必须填写暂停原因': 'The suspension reason is required',
  '确认暂停': 'Confirm Pause',
  '恢复后客户可以立即重新试算和创建订单，确定继续吗？': 'Customers can quote and create orders again immediately after resuming. Continue?',
  '客户新订单入口已恢复': 'Customer order intake has been resumed',
  '客户新订单入口已暂停': 'Customer order intake has been paused',
  '运行控制保存失败': 'Failed to save the operation control',
  '等待管理员核对上游结果': 'Waiting for the administrator to verify the upstream result',
  '上游预报失败': 'Upstream submission failed',
  '消息列表': 'Message List',
  '消息内容': 'Message Content',
  '账单扣款': 'Billing Deposit Debit',
  '账单待补款': 'Billing Shortfall',
  '争议进度': 'Dispute Progress',
  '冻结金额释放': 'Frozen Amount Released',
  '资金消息': 'Funds Message',
  '峰值': 'Peak',
  '内存消耗': 'Memory Usage',
  '正在加载服务监控数据...': 'Loading server monitoring data...',
  '图片': 'Image',
  '文档': 'Document',
  '未知': 'Unknown',
  '保证金管理': 'Deposit Management',
  '字典类型不能为空': 'Dictionary type cannot be empty',

  // 订单出账 / 账单导入 / 常用包裹 / 回收站
  '查看每次出账记录': 'View every billing record',
  '未出账件数': 'Unbilled Pieces',
  '剩余冻结': 'Remaining Frozen',
  '出账金额': 'Billed Amount',
  '查看每次出账金额': 'View the amount of every billing',
  'API原始运价': 'Original API Freight',
  '当前利润': 'Current Profit',
  '资金退回状态': 'Funds Refund Status',
  '立即退回冻结': 'Refund Frozen Now',
  '出账次数': 'Billing Count',
  '平台累计出账': 'Platform Cumulative Billing',
  '确认附加费': 'Confirm Surcharge',
  '负差额记录（不退款）': 'Negative Difference Records (non-refundable)',
  '账单余额返还': 'Statement Balance Refund',
  '待处理（含处理中）': 'Pending (including in progress)',
  '例如：小号纸箱': 'e.g. small carton',
  '预报重量单位': 'Declared Weight Unit',
  '订单出账记录': 'Order Billing Records',
  '总件数': 'Total Pieces',
  '已出账 / 未出账': 'Billed / Unbilled',
  '累计出账金额': 'Cumulative Billed Amount',
  '第几次出账': 'Billing Sequence',
  '本次件数': 'Pieces This Time',
  '客户端出账金额': 'Customer Billed Amount',
  '平台本次成本': 'Platform Cost This Time',
  '分摊原始运价': 'Allocated Base Freight',
  '本次冻结结算': 'Frozen Settlement This Time',
  '平台实际费用低于锁定报价时，按少补不退规则计入平台利润': 'When the actual platform cost is below the locked quote, the difference is booked as platform profit under the "top up shortage, no refund" rule',
  '强平金额': 'Forced Settlement Amount',
  '本次利润': 'Profit This Time',
  '押金扣款/返还': 'Deposit Debit / Return',
  '余额补足/退回': 'Balance Top-up / Refund',
  '扣押金说明': 'Deposit Debit Note',
  '处理结果': 'Processing Result',
  '订单出账记录读取失败': 'Failed to load the order billing records',
  '编辑账单扣押金说明': 'Edit Deposit Debit Note',
  '这里只修改账单的说明文字，不会改动金额、押金或资金流水。': 'This only edits the note on the statement. Amounts, deposits and fund records are not changed.',
  '说明为什么出现扣押金，例如：平台燃油附加费、偏远地区附加费、账单更正等': 'Explain why the deposit was debited, e.g. platform fuel surcharge, remote area surcharge, statement correction',
  '保存说明': 'Save Note',
  '账单说明已保存': 'The statement note has been saved',
  '账单说明保存失败': 'Failed to save the statement note',
  '问题级别': 'Issue Level',
  '问题类型': 'Issue Type',
  '余额补足': 'Balance Top-up',
  '具体原因': 'Details',
  '冻结结算': 'Frozen Settlement',
  '分摊基础成本': 'Allocated Base Cost',
  '单件利润': 'Profit per Piece',
  '单件成本': 'Cost per Piece',
  '待结费用': 'Outstanding Fees',
  '押金净扣款': 'Net Deposit Debit',
  '本期上游费用': 'Upstream Fee This Period',
  '本期基础售价': 'Base Selling Price This Period',
  '本期对应金额': 'Corresponding Amount This Period',
  '本期差额': 'Difference This Period',
  '本期新增件数': 'New Pieces This Period',
  '编辑说明': 'Edit Note',
  '退回余额': 'Refunded Balance',
  '预报重': 'Declared Weight',
  '处理建议': 'Suggested Action',
  '基础利润': 'Base Profit',
  '本批件数': 'Pieces This Batch',
  '附加费增减': 'Surcharge Adjustment',
  '异常明细': 'Issue Details',
  '查看完整明细': 'View Full Details',
  '账单导入存在异常': 'The statement import has issues',
  '严重异常已拦截': 'Critical Issues Blocked',
  '匹配冲突': 'Matching Conflict',
  '处理失败': 'Processing Failed',
  '待补费用': 'Outstanding Charges',
  '订单未匹配': 'Order Not Matched',
  '重复已跳过': 'Duplicates Skipped',
  '严重': 'Critical',
  '平台费用覆盖异常': 'Platform Fee Override Exception',
  '系统处理失败': 'System Processing Failed',
  '订单匹配冲突': 'Order Matching Conflict',
  '账单数据校验失败': 'Statement Data Validation Failed',
  '冻结款已退回': 'Frozen Funds Refunded',
  '待退回冻结款': 'Frozen Funds Pending Refund',
  '待退回扣款': 'Debit Pending Refund',
  '未扣款，无需退回': 'No debit recorded, nothing to refund',
  '资金状态待核对': 'Funds Status Pending Review',
  '常用包裹读取失败': 'Failed to load the saved packages',
  '常用包裹已保存': 'The saved package has been stored',
  '常用包裹保存失败': 'Failed to save the package',
  '常用包裹已删除': 'The saved package has been deleted',
  '确认退回': 'Confirm Refund',
  '立即退回冻结金额': 'Refund the Frozen Amount Now',
  '冻结金额已退回，流水已记录': 'The frozen amount has been refunded and the transaction recorded',
  '冻结金额退回失败，请刷新后重试': 'Failed to refund the frozen amount. Refresh and try again',
  '该订单冻结款已退回，本次删除仅移入回收站，不会重复退款。确认删除？': 'The frozen funds of this order have been refunded. This deletion only moves it to the recycle bin and will not refund again. Confirm deletion?',
  '将先删除原平台订单，成功后移入回收站；冻结金额将在次日释放，如需立即退回请联系管理员。确认删除？': 'The order will be deleted on the upstream platform first and then moved to the recycle bin. The frozen amount will be released the next day; contact an administrator for an immediate refund. Confirm deletion?',
  '预报失败的订单将移入回收站，冻结金额将在次日释放，如需立即退回请联系管理员。确认删除？': 'Orders that failed submission are moved to the recycle bin. The frozen amount will be released the next day; contact an administrator for an immediate refund. Confirm deletion?',
  '订单已移入回收站，冻结款此前已退回': 'The order has been moved to the recycle bin. The frozen funds were refunded earlier',
  '订单已移入回收站，冻结金额可由管理员立即退回或次日自动释放': 'The order has been moved to the recycle bin. The frozen amount can be refunded immediately by an administrator or released automatically the next day',
  '订单已移入回收站，冻结金额将在次日释放；如需立即退回请联系管理员': 'The order has been moved to the recycle bin. The frozen amount will be released the next day; contact an administrator for an immediate refund',
  '确认恢复到订单列表？恢复后将重新冻结该订单金额。': 'Restore it to the order list? The order amount will be frozen again after restoring.',
  '确认将该订单恢复到订单列表？': 'Restore this order to the order list?',
  '充值流水未确认写入，本次充值已取消，请刷新后核对': 'The recharge transaction was not confirmed. This recharge has been cancelled; refresh and verify',
  '客户累计扣费': 'Customer Cumulative Charge',
  '累计出账件数': 'Cumulative Billed Pieces',
  '剩余未出账件数': 'Remaining Unbilled Pieces',
  '已全部出账': 'Fully Billed',
  '部分出账': 'Partially Billed',

  // 用户状态与监控图表
  '用户已启用': 'The user has been enabled',
  '用户已禁用': 'The user has been disabled',
  '命令': 'Command',

  // 押金阈值（创建客户时设置 / 客户管理列表调整）
  '押金阈值': 'Deposit Threshold',
  '设置押金阈值': 'Set Deposit Threshold',
  '押金阈值已保存': 'Deposit threshold saved',
  '押金阈值必须在 0 至 99999999.99 之间': 'Deposit threshold must be between 0 and 99999999.99',
  '初始押金阈值': 'Initial Deposit Threshold',
  '初始押金阈值不能为空': 'Initial deposit threshold is required',
  '该客户应维持的押金金额，决定充值时需要补足的缺口': 'The deposit the customer must maintain; it determines the shortfall to top up',
  '该客户应维持的押金金额。充值时只补足与阈值的差额，退还押金不会下调阈值。填写 0 表示恢复为「首次充值金额自动作为阈值」。': 'The deposit the customer must maintain. Top-ups only cover the gap to this threshold and returning a deposit does not lower it. Enter 0 to fall back to using the first top-up amount as the threshold',
  '当前押金已达到目标押金，无需补充': 'The deposit already meets the target; no top-up needed',
  '该客户尚未设置押金阈值，本次充值金额将自动作为目标押金。': 'No deposit threshold is set for this customer yet, so this top-up amount becomes the target',
  '请填写押金阈值': 'Please enter the deposit threshold',
  '押金阈值应在0至99999999.99之间，最多保留2位小数': 'Deposit threshold must be between 0 and 99999999.99, with at most 2 decimal places',
  '客户不存在或不是普通客户': 'Customer not found or is not a regular customer',
  '客户不存在': 'Customer not found',

  // 押金充值放开上限：超出待补押金的部分转入账户余额
  '充值金额可以先补足待补押金，超出待补金额的部分将自动转入该客户的账户余额。': 'The amount covers the outstanding deposit first; anything above it is credited to the customer wallet balance.',

  // 创建订单：运费试算时自动保存包裹信息到常用包裹
  '试算时自动保存包裹信息；包裹信息变更后需重新试算': 'Package details are saved automatically when you estimate; re-estimate after any change',
  '包裹信息已保存到常用包裹': 'Package details saved to Saved Packages',
  '暂无试算结果，包裹信息变更后需重新试算': 'No estimate yet. Re-run the estimate after changing package details'
})

Object.assign(translations, {
  '暂无消息': 'No messages',
  '是否清除缓存列表 ': 'Clear cache list ',
  '是否删除缓存 ': 'Delete cache ',
  '单机': 'Standalone',
  '集群': 'Cluster',
  '是否下线 "': 'Sign out "',
  '仅允许系统白名单任务，例如：systemTask.closeSchedulerJob()': 'Only allow system-whitelisted jobs, for example: systemTask.closeSchedulerJob()',
  '禁止类名反射和未登记的 Bean / 方法': 'Class-name reflection and unregistered beans or methods are prohibited',
  '创建时间：': 'Created at: ',
  '是否重置用户 ': 'Reset the password for user ',
  ' 的密码？': '?',
  '当前筛选范围没有接口失败记录': 'No API failure records match the current filters',
  '系统任务': 'System task',
  '至': 'to',
  '暂无争议记录': 'No dispute records',
  '暂无处理记录': 'No processing records',
  '暂无成功订单': 'No successful orders',
  '暂无客户，请刷新重试': 'No customers. Refresh and try again',
  '请输入完整订单号': 'Enter the complete order number',
  '单件成本 (USD)': 'Unit Cost (USD)',
  '单件利润 (USD)': 'Unit Profit (USD)',
  '平台累计出账 (USD)': 'Cumulative Provider Billing (USD)',
  '确认附加费 (USD)': 'Confirmed Surcharge (USD)',
  '负差额记录 (USD)': 'Negative Difference (USD)',
  '当前押金已补足，暂无待补明细': 'The deposit is fully funded; no outstanding details',
  '该客户暂无预报成功的订单': 'This customer has no successfully submitted orders',
  '= 总余额 − 冻结金额': '= Total Balance − Frozen Amount',
  '总余额 (USD)': 'Total Balance (USD)',
  '冻结金额 (USD)': 'Frozen Amount (USD)',
  '可用余额 (USD)': 'Available Balance (USD)',
  '暂无索赔记录': 'No claim records',
  '暂无调整记录': 'No adjustment records',
  '该订单暂无出账记录': 'This order has no billing records',
  '撤销原因': 'Reversal Reason',
  '暂无导入明细': 'No import details',
  '本次出账件数': 'Billed Pieces This Time',
  '本次平台费用': 'Provider Fee This Time',
  '本次分摊成本': 'Allocated Cost This Time',
  '冻结金额结算': 'Frozen Amount Settlement',
  '本次强平金额': 'Forced Settlement Amount',
  '平台费-分摊成本': 'Provider Fee − Allocated Cost',
  '本次押金扣款': 'Deposit Deduction This Time',
  '余额补足押金': 'Balance Used to Replenish Deposit',
  '本次件数售价': 'Sales Price for These Pieces',
  '客户端本次出账': 'Customer Billing This Time',
  '平台单件费用': 'Provider Unit Fee',
  '订单单件利润': 'Order Unit Profit',
  '扣押金说明/备注': 'Deposit Deduction Details / Notes',
  '处理结果与具体原因': 'Result and Detailed Reason',
  '订单号码读取失败，请重新勾选自动生成': 'Could not load the order number. Re-select automatic generation',
  '撤销后会按这次账单的原资金来源反向入账，并把对应件数和金额恢复为未出账、重新冻结。原账单和撤销流水都会保留。请输入撤销原因：': 'The reversal credits funds back to their original sources, restores the related pieces and amount to unbilled status, and freezes them again. The original billing record and reversal transaction are retained. Enter the reversal reason:',
  '撤销本次出账': 'Reverse This Billing',
  '确认撤销': 'Confirm Reversal',
  '例如：平台账单件数录入错误，需要重新导入': 'For example: the provider billing piece count was entered incorrectly and must be imported again',
  '请填写撤销原因': 'Enter the reversal reason',
  '本次出账已撤销，资金已按原来源退回并恢复冻结': 'This billing was reversed; funds were returned to their original sources and frozen again',
  '撤销出账失败': 'Failed to reverse billing',
  '同名文件不能再次导入；不同名文件即使内容相同也按新账单累计，累计出账件数不能超过订单总件数。系统会逐行核对客户单号、主单号、件数和平台费用。每一次出账独立计算：客户端只显示本次件数对应的锁定售价；平台费用超过本次件数分摊成本的部分单独扣押金，并按押金目标值从可用余额补足；平台费用低于本次分摊成本的差额按“少补不退”记为本次强平，不能抵扣以后账单。件数为 0 时，整笔平台费用作为补充费用扣押金。导入完成后会逐行列出处理结果、具体原因和建议。确认导入？': 'Files with the same name cannot be imported twice. A differently named file is treated as a new statement even if its content is identical, and cumulative billed pieces cannot exceed the order total. The system verifies the customer reference, master waybill, piece count and provider fee row by row. Each billing is calculated independently: the customer sees only the locked selling price for the billed pieces; any provider fee above the allocated cost is deducted from the deposit and the deposit is replenished from available balance to its target; any provider fee below the allocated cost is recorded as a forced settlement without refund and cannot offset future statements. When the piece count is 0, the entire provider fee is treated as an additional charge against the deposit. After import, each row lists the result, detailed reason and recommendation. Import now?',
  '请填写包裹名称': 'Enter the package name',
  '请填写有效的重量和长宽高': 'Enter valid weight and dimensions',
  '暂无关联资金流水': 'No related transactions',
  '暂无报价': 'No quotes',
  '请上传 ': 'Please upload ',
  '格式的文件': ' file format',
  '文件大小不得超过 ': 'File size must not exceed '
})

Object.assign(translations, {
  '文件存储失败，请检查对象存储服务': 'File storage failed. Check the object storage service',
  '文件读取失败，请检查对象存储服务': 'File retrieval failed. Check the object storage service',
  '对象存储查询失败': 'Object storage query failed',
  '文件删除失败，请检查对象存储服务': 'File deletion failed. Check the object storage service',
  'MinIO 配置不完整，请设置 MINIO_ENDPOINT、MINIO_ACCESS_KEY、MINIO_SECRET_KEY 和 MINIO_BUCKET': 'MinIO configuration is incomplete. Set MINIO_ENDPOINT, MINIO_ACCESS_KEY, MINIO_SECRET_KEY and MINIO_BUCKET',
  '无效的文件标识': 'Invalid file identifier',
  '文件上传到对象存储失败': 'Failed to upload the file to object storage',
  '无操作自动登出时间必须在 1 至 120 分钟之间': 'Idle logout time must be between 1 and 120 minutes',
  '不能修改超级管理员角色': 'The super administrator role cannot be modified',
  '客户用户不能分配超级管理员角色': 'A customer user cannot be assigned the super administrator role',
  '本系统仅支持超级管理员和客户用户角色': 'This system supports only super administrator and customer user roles',
  '只能修改本人资料': 'You can modify only your own profile',
  '只能修改本人头像': 'You can modify only your own avatar',
  '请填写初始附加费比例': 'Enter the initial surcharge percentage',
  '用户不存在': 'User not found',
  '密码重置失败，请刷新后重试': 'Password reset failed. Refresh and try again',
  '该客户已有订单或资金记录，请停用账号，不能删除': 'This customer has orders or financial records. Disable the account instead of deleting it',
  '初始附加费比例应在0至1000%之间，最多保留4位小数': 'The initial surcharge percentage must be between 0% and 1000%, with up to 4 decimal places',
  '相关接口请求暂不可用，请稍后重试': 'The provider service is temporarily unavailable. Try again later',
  '面单地址无效': 'Invalid shipping label URL',
  '仅管理员可迁移文件': 'Only administrators can migrate files',
  'MinIO 文件校验失败': 'MinIO file verification failed',
  'SHA-256 校验失败': 'SHA-256 verification failed',
  '暂停客户下单时必须填写原因': 'A reason is required when pausing customer order creation',
  '运行控制状态保存失败': 'Failed to save the operational control status',
  '汇率必须是有效数字': 'The exchange rate must be a valid number',
  '汇率须大于0、不超过100，且最多保留4位小数': 'The exchange rate must be greater than 0 and no more than 100, with up to 4 decimal places',
  '所选产品不属于当前发货区域，请刷新产品列表后重新选择': 'The selected product does not belong to the current shipping region. Refresh the product list and select again',
  '产品所属区域只能选择美中、美东或美西': 'The product region must be US Central, US East or US West',
  '产品不存在，请刷新后重试': 'Product not found. Refresh and try again',
  '客户不存在或已停用': 'Customer not found or disabled',
  '加价比例格式不正确': 'Invalid markup percentage format',
  '相关接口产品数据不完整，请稍后重试': 'Provider product data is incomplete. Try again later',
  '相关接口产品数据不完整或编码重复，请稍后重试': 'Provider product data is incomplete or contains duplicate codes. Try again later',
  '自动订单标识格式不正确，请刷新后重试': 'The automatic order identifier is invalid. Refresh and try again',
  '订单已生成账单，不允许删除': 'The order has already been billed and cannot be deleted',
  '订单删除退款已完成，不能直接恢复；如需恢复请联系管理员重新核对费用': 'The order deletion refund is complete and the order cannot be restored directly. Contact an administrator to review the charges',
  '客户可用余额不足，无法恢复并重新冻结订单费用': 'The customer has insufficient available balance to restore the order and freeze its fees again',
  '订单退款状态已变化，请刷新回收站后重试': 'The order refund status changed. Refresh the recycle bin and try again',
  '只有预报失败或已完成的订单才能退回冻结金额': 'Frozen funds can be returned only for failed or completed orders',
  '订单仍在正常列表中，请先删除订单后再退回冻结金额': 'The order is still active. Delete it before returning frozen funds',
  '该订单没有可退回的冻结金额': 'This order has no frozen funds to return',
  '备注不能超过500个字符': 'Notes cannot exceed 500 characters',
  '合计金额必须大于0': 'The total amount must be greater than 0',
  '订单已删除，不能导入账单或继续扣费': 'The order has been deleted and cannot be billed or charged further',
  '总件数不能为负数': 'The total piece count cannot be negative',
  '订单预报件数异常，请人工核对': 'The submitted piece count is invalid. Review it manually',
  '订单基础售价未处于可结算状态，请人工核对': 'The order base selling price is not ready for settlement. Review it manually',
  '账单说明不能超过500个字符': 'Billing notes cannot exceed 500 characters',
  '账单明细不存在': 'Billing detail not found',
  '账单说明保存失败，请刷新后重试': 'Failed to save the billing notes. Refresh and try again',
  '撤销原因不能超过500个字符': 'The reversal reason cannot exceed 500 characters'
})

Object.assign(translations, {
  '显示列': 'Visible columns',
  '隐藏列': 'Hidden columns',
  '订单、资金和客户异常集中监控 · 最近更新': 'Orders, funds and customer issues · Last updated',
  '已紧急暂停': 'Temporarily paused',
  '运行正常': 'Operating normally',
  '暂停原因：': 'Pause reason: ',
  '系统维护': 'System maintenance',
  '项': 'items',
  '暂无异常订单': 'No orders requiring attention',
  '近24小时没有接口失败': 'No API failures in the last 24 hours',
  '是否重置用户': 'Reset the password for',
  '的密码？': '?',
  '加载中': 'Loading',
  '重试加载': 'Retry',
  '删除日期': 'Deleted on',
  '件': 'pieces',
  '查看全部历史扣款记录（含已撤销）': 'View all historical charges, including reversed charges',
  '笔': 'transactions',
  '联系管理员恢复': 'Contact an administrator to restore access',
  '条记录': 'records',
  '次': 'times',
  '冲减': 'Reversed ',
  '（原扣': '(original charge ',
  '扣押金': 'Deposit charged ',
  '返押金': 'Deposit refunded ',
  '余额补': 'Funded from balance ',
  '退余额': 'Balance refunded ',
  '未填写': 'Not provided',
  '撤销': 'Reverse',
  '暂无可预览内容': 'Nothing to preview',
  '暂无导入记录': 'No imports',
  '订单基础利润': 'Base order profit',
  '平台费与分摊成本差额': 'Provider charge minus allocated cost',
  '本批押金扣款': 'Deposit charges in this batch',
  '部分成功': 'Partially successful',
  '失败可重试': 'Failed; retry available',
  '暂无可展示的报价': 'No quotes to display',
  '所选产品暂未返回可用价格，请调整包裹信息后重试。': 'No usable prices were returned for the selected products. Adjust the package details and retry.',
  '（约 ¥': '(approx. ¥',
  '计费重：': 'Chargeable weight: ',
  '偏远类型：': 'Remote area type: ',
  '请上传': 'Please upload ',
  '文件大小不得超过': 'File size must not exceed ',
  '账单生成，按本次件数将冻结费用转为正式扣费': 'Statement generated: frozen funds settled for this batch of pieces',
  '账单生成，本次冻结费用正式扣除': 'Statement generated: frozen funds charged for this batch',
  '账单生成，冻结费用正式扣除': 'Statement generated: frozen funds charged',
  '账单扣取押金后从可用余额自动补足': 'Deposit automatically replenished from available balance after statement settlement',
  '押金扣款后从可用余额自动补足': 'Deposit automatically replenished from available balance after a deposit charge',
  '外部预报失败，自动退回冻结费用': 'Provider submission failed; frozen funds released automatically',
  '管理员立即退回冻结金额': 'Frozen funds released immediately by an administrator',
  '订单失败或删除，释放冻结费用': 'Frozen funds released after order failure or deletion',
  '撤销充值时退回押金补足部分': 'Deposit top-up returned when reversing the recharge'
})

Object.assign(translations, {
  'US 美国 UNITED STATES OF AMERICA': 'US UNITED STATES OF AMERICA',
  'AT 奥地利 Austria': 'AT Austria',
  'AU 澳大利亚 Australia': 'AU Australia',
  'BE 比利时 Belgium': 'BE Belgium',
  'BG 保加利亚 Bulgaria': 'BG Bulgaria',
  'CA 加拿大 CANADA': 'CA CANADA',
  'CN 中国 CHINA, PEOPLES REPUBLIC': 'CN CHINA, PEOPLES REPUBLIC',
  'CZ 捷克-捷克共和国 Czech Republic': 'CZ Czech Republic',
  'DE 德国 Germany': 'DE Germany',
  'DK 丹麦 Denmark': 'DK Denmark',
  'EE 爱沙尼亚 Estonia': 'EE Estonia',
  'ES 西班牙 Spain': 'ES Spain',
  'FI 芬兰 Finland': 'FI Finland',
  'FR 法国 France': 'FR France',
  'GB 英国 Great Britain': 'GB Great Britain',
  'GR 希腊 Greece': 'GR Greece',
  'HR 克罗地亚 Croatia': 'HR Croatia',
  'HU 匈牙利 Hungary': 'HU Hungary',
  'IE 爱尔兰 IRELAND': 'IE IRELAND',
  'IT 意大利 Italy': 'IT Italy',
  'LT 立陶宛 Lithuania': 'LT Lithuania',
  'LU 卢森堡 Luxembourg': 'LU Luxembourg',
  'LV 拉脱维亚 Latvia': 'LV Latvia',
  'MX 墨西哥 Mexico': 'MX Mexico',
  'NL 荷兰 Netherlands': 'NL Netherlands',
  'PL 波兰 Poland': 'PL Poland',
  'PT 葡萄牙 Portugal': 'PT Portugal',
  'SE 瑞典 Sweden': 'SE Sweden',
  'SI 斯洛文尼亚 Slovenia': 'SI Slovenia',
  'SK 斯洛伐克 Slovakia': 'SK Slovakia',
  '加西': 'Canada West',
  '加东': 'Canada East',
  '美西加拿大': 'US West / Canada'
})

const reverseTranslations = Object.keys(translations)
  .sort((a, b) => translations[b].length - translations[a].length)
  .reduce((map, key) => {
    if (!map[translations[key]]) map[translations[key]] = key
    return map
  }, {})

const state = Vue.observable({
  locale: typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'zh'
})

// Only explicitly assigned interface fields participate in locale changes.
// Form values, API payloads and customer-authored content are never traversed.
const componentUiText = new WeakMap()

function setUiText (field, source) {
  let fields = componentUiText.get(this)
  if (!fields) { fields = new Map(); componentUiText.set(this, fields) }
  fields.set(field, source)
  this[field] = translateUi(source)
  return this[field]
}

function translateExact (text, dictionary) {
  if (typeof text !== 'string') return text
  const match = /^(\s*)([\s\S]*?)(\s*)$/.exec(text)
  if (!Object.prototype.hasOwnProperty.call(dictionary, match[2])) return text
  const translated = dictionary[match[2]]
  return match[1] + translated + match[3]
}

// Only registered interface copy is translated. A partial replacement can
// rewrite customer names, notices and other content supplied by users.
// 带变量的提示文案：DOM 文本节点按整串精确匹配，无法覆盖插值/拼接出来的句子，
// 这里用正则按模式翻译（注意顺序：更具体的模式要排在更宽泛的前面）。
const dynamicTranslations = [
  [/^管理员撤回押金充值（原流水 (\d+)）$/, m => `Administrator reversed deposit credit (original transaction ${m[1]})`],
  [/^一笔 (.+) USD 的押金充值已由管理员撤回，款项已从押金扣回，请查看资金流水及待补押金。$/, m => `A ${m[1]} USD deposit credit has been reversed by an administrator and deducted from the deposit. Review your transaction details and outstanding deposit.`],
  [/^选择 (\d+)\/(\d+)$/, m => `Selected ${m[1]}/${m[2]}`],
  [/^已选 (\d+) 个产品$/, m => `${m[1]} products selected`],
  [/^共 (\d+) 件，(.+) (.+)$/, m => `${m[1]} pieces, ${m[2]} ${m[3]}`],
  [/^客户应付 (.+) (.+)$/, m => `Customer total ${m[1]} ${m[2]}`],
  [/^（约 ¥(.+)）$/, m => `(approx. ¥${m[1]})`],
  [/^当前费率：1 USD ≈ (.+) CNY$/, m => `Current rate: 1 USD ≈ ${m[1]} CNY`],
  [/^返回(.+)$/, m => `Back to ${toEnglish(m[1])}`],
  [/^当前余额 (.+) USD$/, m => `Current balance ${m[1]} USD`],
  [/^当前押金 (.+) USD$/, m => `Current deposit ${m[1]} USD`],
  [/^确认充值 (.+) USD$/, m => `Confirm recharge of ${m[1]} USD`],
  [/^将统一配置 (\d+) 个产品$/, m => `Apply the same settings to ${m[1]} products`],
  [/^\s*等 (\d+) 个产品$/, m => ` and ${m[1]} more products`],
  [/^客户订单：(.+)$/, m => `Customer order: ${m[1]}`],
  [/^产品：(.+)$/, m => `Product: ${m[1]}`],
  [/^客户实付：(.+) USD$/, m => `Customer payment: ${m[1]} USD`],
  [/^附件 (\d+)$/, m => `Attachment ${m[1]}`],
  [/^(.+)，最多(\d+)张$/, m => `${toEnglish(m[1])}, up to ${m[2]} photos`],
  [/^文件：(.+)$/, m => `File: ${m[1]}`],
  [/^状态：(.+)$/, m => `Status: ${toEnglish(m[1])}`],
  [/^文件 SHA-256：(.+)$/, m => `File SHA-256: ${m[1]}`],
  [/^订单号码：(.+)$/, m => `Order number: ${m[1]}`],
  [/^运单号码：(.+)$/, m => `Tracking number: ${m[1]}`],
  [/^处理提示：(.+)$/, m => `Suggested action: ${toEnglish(m[1])}`],
  [/^已返回 (\d+) \/ (\d+) 个产品$/, m => `${m[1]} / ${m[2]} products returned`],
  [/^文件列表 - (.+)$/, m => `Files - ${m[1]}`],
  [/^([0-9]+) 条未读$/, m => `${m[1]} unread`],
  [/^共 ([0-9]+) 条消息$/, m => `${m[1]} messages`],
  [/^你好，(.+)，这里是你的物流业务概览。$/, m => `Hello, ${m[1]}. Here is your logistics business overview.`],
  [/^你好，(.+)$/, m => `Hello, ${m[1]}`],
  [/^登录时间：(.*?)\s+登录IP：(.*?)（(.*?)）$/, m => `Login time: ${m[1]}  Login IP: ${m[2]} (${m[3]})`],
  [/^是否下线 "(.*)" \?$/, m => `Sign out "${m[1]}"?`],
  [/^是否清除缓存列表 (.+) \?$/, m => `Clear the cache list "${m[1]}"?`],
  [/^是否删除缓存 (.+) \?$/, m => `Delete the cache "${m[1]}"?`],
  [/^请上传 (.+)格式的文件$/, m => `Please upload a file in these formats: ${m[1].trim().replace(/ +/g, ' ')}`],
  [/^文件大小不得超过 ([0-9.]+) MB$/, m => `File size must not exceed ${m[1]} MB`],
  [/^最多上传([0-9]+)张照片$/, m => `Upload up to ${m[1]} photos`],
  [/^请上传至少([0-9]+)张争议证明照片$/, m => `Upload at least ${m[1]} evidence photos`],
  [/^全部产品\(([0-9]+)\)$/, m => `All products (${m[1]})`],
  [/^第 ([0-9]+) 个包裹的件数应为1至999$/, m => `Pieces for package ${m[1]} must be between 1 and 999`],
  [/^请填写第 ([0-9]+) 个包裹的重量和长宽高（输入最多三位小数，换算到接口单位后需大于0且不超过999）$/, m => `Enter the weight and dimensions for package ${m[1]} (up to three decimals; must be greater than 0 and no more than 999 after unit conversion)`],
  [/^本次预报将冻结 (.+) 的订单费用，确认提交？$/, m => `This submission will freeze ${m[1]} in order fees. Confirm?`],
  [/^预报成功，订单费用已冻结：(.+)$/, m => `Submitted successfully. Order fees frozen: ${m[1]}`],
  [/^预报失败，冻结金额已自动退回：(.+)$/, m => `Submission failed. The frozen amount has been refunded automatically: ${m[1]}`],
  [/^订单 (.+) 尚未最终确认，订单费用已冻结，请稍后在订单管理刷新状态，勿重复提交$/, m => `Order ${m[1]} is not finalized yet. Order fees are frozen; refresh the status in Order Management later and do not submit again`],
  [/^([0-9]+) 条订单状态暂时无法同步$/, m => `${m[1]} order status(es) could not be synced`],
  [/^已配置 ([0-9]+) 个产品，其中 ([0-9]+) 个产品的加价比例发生变化$/, m => `${m[1]} product(s) configured; markup changed for ${m[2]} of them`],
  [/^相关接口产品同步完成，共 ([0-9]+) 个$/, m => `API products synced: ${m[1]}`],
  [/^有 ([0-9]+) 个产品无法自动匹配区域，请在产品列表中选择美中、美东或美西。$/, m => `${m[1]} product(s) could not be auto-matched to a zone. Select US Central, US East or US West in the product list.`],
  [/^(.+) 所属区域已更新为 (.+)$/, m => `${m[1]} zone updated to ${m[2]}`],
  [/^凭证已上传：(.+)$/, m => `Document uploaded: ${m[1]}`],
  [/^充值成功：补足押金 (.+) USD，余额入账 (.+) USD$/, m => `Recharged successfully. Deposit topped up by ${m[1]} USD; ${m[2]} USD credited to the balance`],
  [/^充值成功，余额入账 (.+) USD$/, m => `Recharged successfully. ${m[1]} USD credited to the balance`],
  [/^押金充值金额不能超过待补押金 (.+) USD$/, m => `The deposit recharge amount cannot exceed the shortfall of ${m[1]} USD`],
  [/^换算 (.+) cm；接口提交 (.+) cm$/, m => `Converted ${m[1]} cm; submitted to API as ${m[2]} cm`],
  [/^接口提交 (.+)$/, m => `Submitted to API: ${m[1]}`],
  [/^重量\((.+)\)$/, m => `Weight (${m[1]})`],
  [/^长\((.+)\)$/, m => `Length (${m[1]})`],
  [/^宽\((.+)\)$/, m => `Width (${m[1]})`],
  [/^高\((.+)\)$/, m => `Height (${m[1]})`],
  [/^实重\((.+)\)$/, m => `Actual weight (${m[1]})`],
  [/^尺寸\((.+)\)$/, m => `Dimensions (${m[1]})`],
  [/^切换重量单位至 (.+)$/, m => `Switch weight unit to ${m[1]}`],
  [/^切换尺寸单位至 (.+)$/, m => `Switch dimension unit to ${m[1]}`],
  [/^(.+) 等 ([0-9]+) 个产品$/, m => `${m[1]} and ${m[2]} more product(s)`],
  [/^(.+)需大于 0 且不超过 999，最多 ([0-9]+) 位小数$/, m => `${m[1]} must be greater than 0 and no more than 999, with at most ${m[2]} decimal place(s)`],
  [/^确认删除常用包裹“(.+)”？$/, m => `Delete the saved package "${m[1]}"?`],
  [/^已加入常用包裹：(.+)$/, m => `Added to saved packages: ${m[1]}`],
  [/^确认向 (.+) 充值 ([0-9.]+) USD？$/, m => `Recharge ${m[2]} USD for ${m[1]}?`],
  [/^确认立即退回订单 (.+) 的剩余冻结金额 ([0-9.,-]+) ([A-Z]{3})？该操作会写入“订单冻结释放”流水。$/, m => `Refund the remaining frozen amount of ${m[2]} ${m[3]} for order ${m[1]} now? This writes a "frozen amount released" transaction.`],
  [/^确认删除这条 ([0-9.,-]+) USD 的充值记录？系统会保留原记录，并分别撤回余额和押金补足金额；资金不足时无法撤销。$/, m => `Delete this ${m[1]} USD recharge record? The original record is kept and both the balance and the deposit top-up are reversed separately. It cannot be undone if funds are insufficient.`],
  [/^总行数 ([0-9]+)；成功更新 ([0-9]+)；重复跳过 ([0-9]+)；未匹配 ([0-9]+)；匹配冲突 ([0-9]+)；处理错误 ([0-9]+)$/, m => `Total rows ${m[1]}; updated ${m[2]}; duplicates skipped ${m[3]}; unmatched ${m[4]}; conflicts ${m[5]}; errors ${m[6]}`],
  [/^本批新增件数 ([0-9]+)；基础利润 ([0-9.,-]+) USD；附加费增减 ([0-9.,-]+) USD；押金净扣款 ([0-9.,-]+) USD；待补款增减 ([0-9.,-]+) USD$/, m => `New pieces this batch: ${m[1]}; base profit ${m[2]} USD; surcharge adjustment ${m[3]} USD; net deposit debit ${m[4]} USD; outstanding change ${m[5]} USD`],
  [/^【(.+)】【(.+)】Excel 第 ([0-9]+) 行；订单 (.+)；运单 (.+)$/, m => `[${m[1]}][${m[2]}] Excel row ${m[3]}; order ${m[4]}; tracking number ${m[5]}`],
  [/^另有 ([0-9]+) 条异常，请在随后打开的导入明细中查看。$/, m => `${m[1]} more issue(s) not listed here. See the import details that open next.`],
  [/^原因：(.+)$/, m => `Reason: ${m[1]}`],
  [/^处理建议：(.+)$/, m => `Suggested action: ${m[1]}`],
  [/^(.+)对应字典数据为空$/, m => `No dictionary data for ${m[1]}`],
  [/^目标押金 (.+) USD，当前待补 (.+) USD。$/, m => `Target deposit ${m[1]} USD, currently outstanding ${m[2]} USD.`],
  [/^充值 (.+) USD 成功，其中 (.+) USD 补足押金，(.+) USD 转入账户余额$/, m => `Topped up ${m[1]} USD: ${m[2]} USD went to the deposit and ${m[3]} USD to the wallet balance.`],
  [/^充值 (.+) USD 成功，已全部计入押金$/, m => `Topped up ${m[1]} USD, all credited to the deposit.`],
  [/^常用包裹自动保存失败：(.+)$/, m => `Could not save the package automatically: ${m[1]}`],
  [/^包裹 ([0-9]+)$/, m => `Package ${m[1]}`],
  // 宽泛规则放在最后，避免抢先匹配具体文案
  [/^(\S+) 至 (\S+)$/, m => `${m[1]} to ${m[2]}`]
]

function toEnglish (text) {
  if (typeof text === 'string') {
    // 1. 整串命中词典 → 精确词条优先，避免被下面的正则模式抢先改写
    const exact = /^(\s*)([\s\S]*?)(\s*)$/.exec(text)
    if (exact && Object.prototype.hasOwnProperty.call(translations, exact[2])) {
      return exact[1] + translations[exact[2]] + exact[3]
    }
    // 2. 带变量的提示文案
    for (const [pattern, render] of dynamicTranslations) {
      const matched = pattern.exec(text)
      if (matched) return render(matched)
    }
    const balance = /^账户可用余额不足：本次需 ([0-9]+(?:\.[0-9]+)?) ([A-Z]{3})，当前可用 ([0-9]+(?:\.[0-9]+)?) \2。请联系管理员充值美元余额$/.exec(text)
    if (balance) return `Insufficient available balance. Required: ${balance[1]} ${balance[2]}; available: ${balance[3]} ${balance[2]}. Contact an administrator to add funds.`
    const missingColumn = /^账单 Excel 缺少必需列：(客户单号|主单号|合计)$/.exec(text)
    if (missingColumn) return `The statement Excel file is missing the required column: ${translations[missingColumn[1]]}`
    const evidenceCount = /^该争议类型至少需要([0-9]+)张证明照片$/.exec(text)
    if (evidenceCount) return `This dispute type requires at least ${evidenceCount[1]} evidence photos`
    // 表单必填提示：请填写 +（词典里的字段名）
    const pleaseEnter = /^请填写(.+)$/.exec(text)
    if (pleaseEnter && Object.prototype.hasOwnProperty.call(translations, pleaseEnter[1])) {
      return `Please enter: ${translations[pleaseEnter[1]]}`
    }
    // 账单导入完成的汇总弹窗（含明细块）
    const importResult = /^总行数 ([\d]+)，已更新 ([\d]+)，重复跳过 ([\d]+)，未匹配 ([\d]+)，冲突 ([\d]+)，错误 ([\d]+)\n追加应收 ([\d.,-]+) USD，押金净变动 ([\d.,-]+) USD（负数为退还），押金不足 ([\d.,-]+) USD([\s\S]*)$/.exec(text)
    if (importResult) {
      const m = importResult
      const detail = (m[10] || '')
        .replace(/\n异常明细：/, '\nIssues: ')
        .replace(/第(\d+)行/g, 'Row $1')
      return `Total rows ${m[1]}, updated ${m[2]}, duplicates skipped ${m[3]}, unmatched ${m[4]}, conflicts ${m[5]}, errors ${m[6]}\nExtra receivable ${m[7]} USD, net deposit change ${m[8]} USD (negative = refunded), deposit shortfall ${m[9]} USD${detail}`
    }
  }
  return translateExact(text, translations)
}

function toChinese (text) {
  return translateExact(text, reverseTranslations)
}

function translateUi (text, fallback) {
  const source = fallback === undefined ? text : fallback
  return state.locale === 'en' ? toEnglish(source) : source
}

function refreshDocumentTitle () {
  if (typeof document === 'undefined' || !document.title) return
  if (!document.__transportI18nTitle || document.title !== document.__transportI18nRenderedTitle) {
    document.__transportI18nTitle = toChinese(document.title)
  }
  const rendered = state.locale === 'en' ? toEnglish(document.__transportI18nTitle) : document.__transportI18nTitle
  if (document.title !== rendered) document.title = rendered
  document.__transportI18nRenderedTitle = rendered
}

function setLocale (locale) {
  const next = locale === 'en' ? 'en' : 'zh'
  if (state.locale === next) return
  state.locale = next
  ElementLocale.use(next === 'en' ? elementEn : elementZhCN)
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, next)
    window.dispatchEvent(new CustomEvent(LANGUAGE_EVENT, { detail: next }))
  }
  if (typeof document !== 'undefined' && document.documentElement) document.documentElement.lang = next === 'en' ? 'en' : 'zh-CN'
  refreshDocumentTitle()
}

const plugin = {
  install (VueConstructor) {
    // Element UI calls this handler from its own computed labels and render
    // functions, so they also depend on the observable locale without remounts.
    if (ElementLocale.i18n) {
      ElementLocale.i18n((key, options = {}) => {
        const language = state.locale === 'en' ? elementEn : elementZhCN
        const text = key.split('.').reduce((value, part) => value && value[part], language)
        return typeof text === 'string' ? text.replace(/\{(\w+)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(options, name) ? options[name] : match) : undefined
      })
    }
    ElementLocale.use(state.locale === 'en' ? elementEn : elementZhCN)
    refreshDocumentTitle()
    Object.defineProperty(VueConstructor.prototype, '$locale', {
      configurable: true,
      get: () => state.locale
    })
    VueConstructor.prototype.$t = translateUi
    VueConstructor.prototype.$setLocale = setLocale
    VueConstructor.prototype.$isEnglish = () => state.locale === 'en'
    VueConstructor.prototype.$setUiText = setUiText
    VueConstructor.mixin({
      watch: {
        $locale () {
          const fields = componentUiText.get(this)
          if (fields) fields.forEach((source, field) => { this[field] = translateUi(source) })
          this.$forceUpdate()
          // Existing validation messages belong to the old language. Clear the
          // messages without resetting fields; the next validation uses getters.
          Object.values(this.$refs || {}).flat().forEach(ref => {
            if (ref && ref.$options && ref.$options.name === 'ElForm' && ref.clearValidate) ref.clearValidate()
          })
        }
      }
    })
  }
}

export { setLocale, state as localeState, toEnglish, toChinese, translateUi, LANGUAGE_EVENT }
export default plugin
